const $ = require('jquery');

const constants = require('../data/constants');
const Ui = require('./Ui');
const File = require('../data/File');
const Segment = require('../data/Segment');
const SegmentDrawer = require('./SegmentDrawer');
const MappingUtils = require('./MappingUtils');
const Map = require('./Map');
const TurnRestrictions = require('./TurnRestrictions');
const SegmentTimeDomain = require('./SegmentTimeDomain');
const MapDot = require('../data/MapDot');
const MapDots = require('../data/MapDots');

class OpenFile {
  /**
   * Handles operations for the currently opened file
   *
   * @param {File} file
   * @param {Caretaker} caretaker
   * @param {Map} map
   * @param {Api} api
   * @param {String} sessionId
   * @param {Preloader} preloader
   * @param {Localization} localization
   * @param {Storage} storage
   * @param {String} provider
   */
  constructor(file, caretaker, map, api, sessionId, preloader, localization, storage, provider, addressRouting, truckAttributes) {
    this._file = file;
    this._caretaker = caretaker;
    this._map = map;
    this._provider = provider;
    this._api = api;
    this._sessionId = sessionId;
    this._preloader = preloader;
    this._localization = localization;
    this._storage = storage;
    this._addressRouting = addressRouting;
    this._latestSegment = null;
    this._latestAdjacentSegment = null;
    this._latestEditedTruckAttributes = null;
    this._latestTruckAttributesTimeDomain = null;
    this._segmentDrawer = new SegmentDrawer(this._map, this.prepareMatchSegment.bind(this), localization);
    this._totalUnsavedChanges = 0;
    this._currentEditedSegment = null;
    this._drawnSegments = [];
    this._segmentInitialState = {};
    this.mousePositionOnMap = null;
    this.uiCreateSegmentModal = $('.modal-create-segment');
    this.uiCreateSegmentTimeFrameModal = $('.segment-time-frame');
    this.uiCreateSegmentTruckAttributeModal = $('.truck-attribute');
    this.uiCreateCutPointModal = $('.create-cut-point');
    this.uiModifyStreetModal = $('.modal-modify-street');
    this.uiCreateDepotModal = $('.modal-depot');
    this.uiSegmentListModal = $('.modal-segment-list');
    this.uiEditFileInfoModal = $('.modal-change-file-info');
    this.uiSegmentListContextMenu = $('#segmentlist-row-context-menu');
    this.uiSegmentTypeContextMenu = $('#segment-type-context-menu');
    this.uiCreateSegmentForm = $('#createSegmentForm');
    this.uiModifyStreetForm = $('#modifyStreetForm');
    this.uiMapVersionWarning = $('#modalMapVersionWarning');
    this.uiLimitReachModal = $('#modalLimitReached');
    this.iwTruckAttributes = truckAttributes;
    this.editGeometrySegment = null;
    this.user = null;
    this.currentBuildVersion = null;
    this.olrString = `olrclient_${file.company}_${file.user}_${file.name}`;
    this.permissions = null;
    this.hasSegmentPermission = true;
    this.hasGeometryPermission = true;
    this.hasTurnRestrictionPermission = true;

    this._storage.getOption('permissions')
      .then(result => {
        this.permissions = result;
        this.setPermissions();

        this.activateTruckAttributes();
      });

    this._storage.getOption('user')
      .then(result => {
        this.user = result;
      });

    this._file.onChange = fileVersion => this.fileChanged(fileVersion);

    this.updateSaveBadge();

    this.createMinimap(this.olrString);
    this.createGeometryMinimap(this.olrString);
    this.createCutPointMinimap(this.olrString);
    this.createEditTurnRestrictionMinimap(this.olrString);
    this.createDepotMinimap(this.olrString);

    this._turnRestrictions = new TurnRestrictions(
      this._map,
      this._api,
      this._sessionId,
      this._localization,
    );

    setTimeout(() => {
      this._turnRestrictions.enable(this);
      this.drawOnMap(true);
    }, 500); // so the map has time to zoom

    this.mergeGeometryChanges(this.olrString);
    this.getBuildVersion()
      .then(() => {
        if(!this.checkFileMapVersion(this._file.segments)) {
          this.uiMapVersionWarning.modal('show');
        }
      });
    this.addListeners();
  }

  get file() {
    return this._file;
  }

  createMinimap(olrString) {
      $('#segment-minimap').html('');
      this._minimap = null;

      new Map('#segment-minimap', this._storage, this._provider)
        .then((map) => {
          this._minimap = map;
          this._minimap.init();
          this._minimap.initMainRenderer();

          this.mergeGeometryChangesMiniMap(olrString);
        })
        .catch((error) => {
          Ui.showModalError(error);
        });
  }

  createGeometryMinimap(olrString) {
    $('#segment-minimap-modfiy-street').html('');
    this._geometryMinimap = null;

    new Map('#segment-minimap-modfiy-street', this._storage, this._provider)
      .then((map) => {
        this._geometryMinimap = map;
        this._geometryMinimap.init();
        this._geometryMinimap.initMainRenderer();

        this.mergeGeometryChangesGeometryMap(olrString);
      })
      .catch((error) => {
        Ui.showModalError(error);
      })
  }

  createCutPointMinimap(olrString) {
    $('#cutpoint-minimap').html('');
    this._cutPointMinimap = null;

    new Map('#cutpoint-minimap', this._storage, this._provider)
      .then((map) => {
        this._cutPointMinimap = map;
        this._cutPointMinimap.init();
        this._cutPointMinimap.initMainRenderer();

        this.mergeGeometryChangesCutPointMap(olrString);
      })
      .catch((error) => {
        Ui.showModalError(error);
      })
  }

  createDepotMinimap(olrString) {
    $('#segment-minimap-create-depot').html('');
    this._depotMinimap = null;

    new Map('#segment-minimap-create-depot', this._storage, this._provider)
      .then((map) => {
        this._depotMinimap = map;
        this._depotMinimap.init();
        this._depotMinimap.initMainRenderer();

        this._depotMinimap.map.getOptions().resizeToContainer($('#segment-minimap-container-create-depot').get(0));
        this.mergeGeometryChangesDepotMap(olrString);
      })
      .catch((error) => {
        Ui.showModalError(error);
      })
  }

  createEditTurnRestrictionMinimap() {
    $('#turnrestriction-minimap').html('');
    this._editTurnRestrctionMinimap = null;

    new Map('#turnrestriction-minimap', this._storage, this._provider)
      .then((map) => {
        this._editTurnRestrctionMinimap = map;
        this._editTurnRestrctionMinimap.init();
        this._editTurnRestrctionMinimap.initMainRenderer();

        this.mergeGeometryChangesTurnRestrictionMap(this.olrString);
      })
      .catch((error) => {
        Ui.showModalError(error);
      })
  }

  activateTruckAttributes() {
    this.iwTruckAttributes.setClickHandler((marker, properties, coordinates, event, olrCode) => {
      if(event.ctrlKey || event.which !== 1) {
        return;
      }

      let balloonContainer = this.createTruckAttributesBalloon(properties, false);

      if(this.hasSegmentPermission) {
        balloonContainer.find('#truck-attribute-edit').off().on('click', () => {
          this.resetTruckAttributeModal();
          this.fillTruckAttributesFormFromIWTruckAttribute(properties);
          this._latestEditedTruckAttributes = properties;
          let wgsCoord = coordinates.map(coord => coord.toWGS84());

          let attributes = {};
          attributes.detourEditor_originalTruckAttributes = this.createRestrictionStringFromMarker(properties);

          this._latestSegment = new Segment(null, coordinates.map(coord => coord.toWGS84()), olrCode, attributes, constants.SEGMENT_NEW);
          this.showAddSegmentForm();
          this._latestEditedTruckAttributes = null;
        });

        balloonContainer.find('#truck-attribute-remove').off().on('click', () => {
          this._latestEditedTruckAttributes = properties;
          let wgsCoord = coordinates.map(coord => coord.toWGS84());
          this.createEmptyTASegment(wgsCoord, properties, olrCode);
          this._map.map.removeInfoBalloon();
          this._latestEditedTruckAttributes = null;
        });
      } else {
        balloonContainer.find('#truck-attribute-options').addClass('d-none');
      }

      this._map.map.openInfoBalloon(marker._coordinate, balloonContainer.get(0));
    })
  }

  mergeGeometryChanges(detourProfile) {
    let aliases;
    if(window.showBirdsview) {
      aliases = this._map.map.getOptions().getMapTypeByName(window.mapType).getTilesServerConfig().getAliases();
    } else {
      aliases = this._map.map.getCurrentMapType().getTilesServerConfig().getAliases();
    }
    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + this._provider;
    });

    if(window.showBirdsview) {
      this._map.map.getOptions().getMapTypeByName(window.mapType).getTilesServerConfig().setAliases(aliases);
    } else {
      this._map.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    }

    this._map.map.refreshTiles();
  }

  mergeGeometryChangesGeometryMap(detourProfile) {
    let aliases = this._geometryMinimap.map.getCurrentMapType().getTilesServerConfig().getAliases();
    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + this._provider;
    });
    this._geometryMinimap.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    this._geometryMinimap.map.refreshTiles();
  }

  mergeGeometryChangesMiniMap(detourProfile) {
    let aliases = this._minimap.map.getCurrentMapType().getTilesServerConfig().getAliases();
    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + this._provider;
    });
    this._minimap.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    this._minimap.map.refreshTiles();
  }

  mergeGeometryChangesCutPointMap(detourProfile) {
    let aliases = this._minimap.map.getCurrentMapType().getTilesServerConfig().getAliases();
    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + this._provider;
    });
    this._cutPointMinimap.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    this._cutPointMinimap.map.refreshTiles();
  }

  mergeGeometryChangesTurnRestrictionMap(detourProfile) {
    let aliases = this._editTurnRestrctionMinimap.map.getCurrentMapType().getTilesServerConfig().getAliases();
    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + this._provider;
    });
    this._editTurnRestrctionMinimap.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    this._editTurnRestrctionMinimap.map.refreshTiles();
  }

  mergeGeometryChangesDepotMap(detourProfile) {
    let aliases = this._editTurnRestrctionMinimap.map.getCurrentMapType().getTilesServerConfig().getAliases();
    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + this._provider;
    });
    this._depotMinimap.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    this._depotMinimap.map.refreshTiles();
  }

  removeParameter(url, parameter) {
    let indexStart = url.indexOf('&' + parameter);
    if (indexStart < 0) {
      return url;
    }
    else {
      let indexEnd = url.indexOf('&', indexStart + 1);
      if (indexEnd < 0) {
        return url.substr(0, indexStart);
      }
      else {
        return url.substr(0, indexStart) + url.substr(indexEnd);
      }
    }
  }


  fileChanged() {
    this._caretaker.add(this._file.serialize());
  }

  updateSaveBadge() {
    this._totalUnsavedChanges = this._file.segments.reduce((total, segment) => {
      if (segment.flag !== constants.SEGMENT_PUBLISHED) {
        return total + 1;
      }

      return total;
    }, 0);

    Ui.updateSaveBadge(this._totalUnsavedChanges);
  }

  drawOnMap(doZoom, recheckFile) {
    this.clearPreviouslyDrawSegments();
    this._map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._map.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    let coordinates = [];

    this._file.segments.forEach((segment) => {
      if (segment.flag === constants.SEGMENT_DELETED) return;

      this.drawSegment(this._map, segment, false, true, true);

      coordinates = coordinates.concat(segment.coordinates);
    });

    if(this._addressRouting.emergencyCircle) {
      this._addressRouting.emergencyCircle = this._map.renderer.drawCircle(this._addressRouting.emergencyCircle.coord, this._addressRouting.emergencyCircle.radius, this._addressRouting.emergencyCircle.attributes);
      this._map.renderer.moveToBottom(this._addressRouting.emergencyCircle);
    }

    this._map.renderer.render();

    if (doZoom) {
      this._map.zoomToCoordinates(coordinates, 0);
    }

    if(recheckFile) {
      this.checkSegments(false);
    }
  }

  clearPreviouslyDrawSegments() {
    this._map.renderer.clearContainer();
    /*
    this._drawnSegments.forEach((segment) => {
      this._map.renderer.removeElement(segment);
    });
    */
    this._drawnSegments = [];
  }

  clearDrawnSegment(segment) {
    this._drawnSegments.forEach((drawn) => {
      if(drawn.hash === segment.hash) {
        this._map.renderer.removeElement(drawn.polyline);

        if(segment.type === constants.SEGMENT_TYPE_CUT_POINT) {
          drawn.markers.forEach(marker => {
            this._map.map.getOverlayManager().getLayer(
              constants.CUT_POINT_MARKERS_LAYER_ID,
            ).removeOverlay(marker);
          })
        } else {
          drawn.markers.forEach(marker => {
            this._map.map.getOverlayManager().getLayer(
              constants.SEGMENT_MARKERS_LAYER_ID,
            ).removeOverlay(marker);
          })
        }
      }
    });
  }

  hideGeometrySegments() {
    this._drawnSegments.forEach(drawn => {
      if(drawn.category === 'Geometry') {
        drawn.polyline.shapes.forEach((shape) => {
          shape.style.opacity = 0;
        });

        drawn.markers.forEach(marker => {
          marker.setVisible(false);
        })
      }
    })
  }

  static drawSegmentDirectionMarker(map, coordinate, segmentType, isExpired) {

    let options = { fill: 'red'};

    let iconFile = 'img/Symbol_Sperren_bg.svg';
    let className = isExpired ? "marker-closure-expired" : "marker-closure";

    if(segmentType === constants.SEGMENT_PRIORITIZE) {
      options.fill = 'blue';
      iconFile = 'img/Symbol_Priorisieren_bg.svg';
      className = "marker-priority";
    } else if(segmentType === constants.SEGMENT_PENALIZE) {
      options.fill = 'yellow';
      iconFile = 'img/Symbol_Vermeiden_bg.svg';
      className = "marker-penalize";
    } else if(segmentType === constants.SEGMENT_UNBLOCK) {
      options.fill = 'green';
      iconFile = 'img/Symbol_Entsperren_bg.svg';
      className = "marker-unblock";
    } else if(segmentType === constants.SEGMENT_TYPE_CUT_POINT) {
      iconFile = 'img/snapped.png';
      className = "marker-cutpoint";
    }

    let hotspot = new window.IWPoint(13, 13);

    //map.renderer.drawCircle(coordinate, 100, options);

    const marker = new IWClassMarker(map.map, coordinate, className);
    marker.setHotspot(hotspot);
    /*
    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon(iconFile, new window.IWPoint(13, 13), new window.IWSize(27, 27));
    marker.setDefaultIcon(icon);*/

    $(marker.getContainer()).addClass('segmentDirectionArrow');
    map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).addOverlay(marker);

    return marker;
  }

  drawDepotCarMarker(map, coordinate, rotation, segment) {
    let hotspot = new window.IWPoint(20, 20);

    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon('img/arrow_black.svg', new window.IWPoint(20, 20), new window.IWSize(40, 40));
    marker.setDefaultIcon(icon);
    marker.setRotation(rotation);
    marker.setHotspot(hotspot);

    map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).addOverlay(marker);

    if(map.container === "#segment-minimap-container-create-depot") return;

    IWEventManager.addCustomListener(marker, 'onclick', (e) => {
      if(event.ctrlKey || event.which !== 1) {
        return;
      }

      const y = this.mousePositionOnMap.top;
      const x = this.mousePositionOnMap.left;

      const currentWindowRec = map.map.getContainer().getBoundingClientRect();

      let posX = (x + 200) > currentWindowRec.width ? (x - 200) : x;
      let posY = (y + 84) > currentWindowRec.height ? (y-184) : y;

      this.showSegmentListContextMenu({
        left: posX, top: posY,
      }, segment);
    });

    marker.onContextMenu = (event) => {
      if(event.ctrlKey || event.which !== 1) {
        return;
      }

      const y = this.mousePositionOnMap.top;
      const x = this.mousePositionOnMap.left;

      const currentWindowRec = map.map.getContainer().getBoundingClientRect();

      let posX = (x + 200) > currentWindowRec.width ? (x - 200) : x;
      let posY = (y + 84) > currentWindowRec.height ? (y-184) : y;

      this.showSegmentListContextMenu({
        left: posX, top: posY,
      }, segment);
    };

    return marker;
  }

  drawCutPointMarker(map, coordinate, segment) {
    /*
    let iconFile = 'img/cutpoint.png';

    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon(iconFile, new window.IWPoint(15, 15), new window.IWSize(30, 30));
    marker.setDefaultIcon(icon);
    */
    let hotspot = new window.IWPoint(13, 13);

    const marker = new IWClassMarker(map.map, coordinate, "marker-cutpoint");
    marker.setHotspot(hotspot);

    map.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).addOverlay(marker);

    if(map.container === "#cutpoint-minimap-container") return;

    IWEventManager.addCustomListener(marker, 'onclick', (e) => {
      if(event.ctrlKey || event.which !== 1) {
        return;
      }

      const y = this.mousePositionOnMap.top;
      const x = this.mousePositionOnMap.left;

      const currentWindowRec = map.map.getContainer().getBoundingClientRect();

      let posX = (x + 200) > currentWindowRec.width ? (x - 200) : x;
      let posY = (y + 84) > currentWindowRec.height ? (y-184) : y;

      this.showSegmentListContextMenu({
        left: posX, top: posY,
      }, segment);
    });

    return marker;
  }

  static drawWarningMarker(map, coordinate, warningText) {
    let iconFile = 'img/warning-sign.svg';

    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon(iconFile, new window.IWPoint(30, 30), new window.IWSize(30, 30));
    marker.setDefaultIcon(icon);

    map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).addOverlay(marker);

    return marker;
  }

  static drawRestrictionMarker(map, coordinate, hotspot) {
    let iconFile = 'img/Symbol_Sperren_bg.svg';

    /*
    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon(iconFile, hotspot, new window.IWSize(27, 27));
    marker.setDefaultIcon(icon);
    */

    const marker = new IWClassMarker(map.map, coordinate, "marker-closure");
    marker.setHotspot(hotspot);

    $(marker.getContainer()).addClass('segmentDirectionArrow');
    map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).addOverlay(marker);

    return marker;
  }

  static drawStreetSnappedMarker(map, coordinate, snapped) {
    let iconFile = 'img/snapped.png';

    if(!snapped) {
      iconFile = 'img/notSnapped.png';
    }

    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon(iconFile, new window.IWPoint(15, 15), new window.IWSize(30, 30));
    marker.setDefaultIcon(icon);

    $(marker.getContainer()).addClass('segmentDirectionArrow');
    map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).addOverlay(marker);
  }

  static createRestrictionRemovedMarker(map, coordinate) {
    /*
    let iconFile = 'img/restriction-removed-marker.svg';

    const marker = new IWMarker(map.map, coordinate);
    const icon = new IWIcon(iconFile, new window.IWPoint(16, 16), new window.IWSize(32, 32));
    marker.setDefaultIcon(icon);
    */

    let hotspot = new window.IWPoint(16, 16);

    const marker = new IWClassMarker(map.map, coordinate, "marker-restriction-removed");
    marker.setHotspot(hotspot);

    return marker;
  }

  drawSegment(map, segment, doRender, addListeners, addToList) {
    if(!OpenFile.isSegmentVisible(segment)) return;

    const markers = this.drawMarker(segment, map, addToList);

    let segmentColor = 'red';
    let segmentLineType = 'dashed';
    let opacity = 1;

    if(segment.type === constants.SEGMENT_CLOSE) {
      segmentColor = 'red';
    } else if (segment.type === constants.SEGMENT_UNBLOCK) {
      segmentColor = 'green';
    } else if(segment.type === constants.SEGMENT_PENALIZE) {
      segmentColor = '#E97F02';
    } else if(segment.type === constants.SEGMENT_PRIORITIZE) {
      segmentColor = 'blue';
    } else if(segment.type === constants.SEGMENT_TRUCK_ATTRIBUTES) {
      segmentColor = 'black';
    } else if(segment.type === constants.SEGMENT_MODIFIED_STREET) {
      segmentColor = 'coral';
      segmentLineType = '';
    } else if(segment._attributes.SegmentType === constants.SEGMENT_TYPE_DIVIDED_STREET || segment._attributes.SegmentType === constants.SEGMENT_TYPE_DISSECTED_STREET) {
      segmentColor = '#40e0d0';
    } else if(segment.type === constants.SEGMENT_TYPE_DELETED_ORIGINAL || segment.type === constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL) {
      segmentColor = '#8B0000';
      opacity = 0.5;
    } else if(segment.type === constants.SEGMENT_TYPE_ADDED_MANEUVER) {
      segmentColor = '#CD9B9B';
    } else if(segment.type === constants.SEGMENT_TYPE_GEOFENCE) {
      segmentColor = 'red';
      segmentLineType = '';
    } else if(segment.type === constants.SEGMENT_TYPE_MODIFIED_SPEED) {
      const originalRoadSpeed = parseInt(segment.getAttributeByName('detourEditor_originalRoadSpeed'));
      const newSpeed = parseInt(segment.getAttributeByName('NewSpeed'));
      if(newSpeed > originalRoadSpeed) {
        segmentColor = 'blue';
      } else {
        segmentColor = '#E97F02';
      }
    }

    const endDate = segment.getAttributeByName("end");

    if(endDate !== null && new Date(endDate).getTime() < Date.now() ) {
      segmentColor = 'dimgray';
    }

    /*
    if(segment.type === constants.SEGMENT_MODIFIED_STREET) {
      map.renderer.drawPolyline(segment.coordinates, {
        stroke: 'black',
        strokeWidth: 6,
        strokeDashStyle: segmentLineType,
        strokeOpacity: 1
      });
    }
    */

    let circle;

    if(segment.type === constants.SEGMENT_TYPE_GEOFENCE) {

      circle = map.renderer.drawCircle(segment.coordinates[0], parseInt(segment.attributes.Radius), {
        fill: '#5c9eed',
        fillOpacity: 0.4,
        stroke: 'black',
        strokeOpacity: 1,
        strokeWidth: 2
      });

      $('#depotRadius').val(parseInt(segment.attributes.Radius));

      $('#depotAngle').val(Math.floor(segment.attributes.Angle));

      if(map.container === "#segment-minimap-create-depot") {

        IWEventManager.addCustomListener(circle, 'onmousedown', (e) => {
          map.map.getOptions().setLeftMouseAction(IWMapOptions.CONTROL_NONE);
          this.startResize(circle, map, segment);
        });

        IWEventManager.addCustomListener(map.map, 'onmouseup', () => {
          IWEventManager.clearListeners(window, 'mousemove');
          map.map.getOptions().setLeftMouseAction(IWMapOptions.CONTROL_MOVE);
        })
      }
    }

    let polyline;

    if(segment.type === constants.SEGMENT_TYPE_ADDED_MANEUVER && segment.attributes.detourEditor_turnArrowCoords) {
      polyline = this.drawManeuver(segment, map);
    } else if(segment.type !== constants.SEGMENT_TYPE_GEOFENCE) {

      polyline = map.renderer.drawPolyline(segment.coordinates, {
        stroke: segmentColor,
        strokeWidth: 5,
        strokeDashStyle: segmentLineType,
        strokeOpacity: opacity
      });
    }

    if (addToList) {
      this._drawnSegments.push({
        hash: segment.hash,
        polyline: polyline,
        markers: markers
      });

      if(circle) {
        this._drawnSegments.push({
          hash: segment.hash,
          polyline: circle,
          markers: markers
        });
        addListeners = false;
      }
    }

    if (addListeners) {

      const segmentCategory = constants.SEGMENT_TYPE_TO_CATEGORY[segment.type];

      IWEventManager.addCustomListener(polyline, 'onmouseover', () => {
        polyline.shapes.forEach((shape) => {
          shape.style.stroke = 'blue'; // eslint-disable-line no-param-reassign
          shape.style.strokeWidth = 15; // eslint-disable-line no-param-reassign
        });
      });

      IWEventManager.addCustomListener(polyline, 'oncontextmenu', () => {
        $('.editor-context-menu').hide();
        const y = this.mousePositionOnMap.top;
        const x = this.mousePositionOnMap.left;

        /*
        let clickedPolylines = [];
        document.elementsFromPoint(x, y).forEach(ele => {
            if(ele.tagName === 'polyline') {
            console.log(ele);
            clickedPolylines.push(this._drawnSegments.find(seg => seg.polyline.shapes[0] && seg.polyline.shapes[0].outerHTML === ele.outerHTML));
          }
        });
        */

        const currentWindowRec = map.map.getContainer().getBoundingClientRect();

        let posX = (x + 200) > currentWindowRec.width ? (x - 200) : x;
        let posY = (y + 84) > currentWindowRec.height ? (y-184) : y;

        this.showSegmentListContextMenu({
          left: posX, top: posY,
        }, segment);
      });

      IWEventManager.addCustomListener(polyline, 'onmouseout', () => {
        polyline.shapes.forEach((shape) => {
          shape.style.stroke = segmentColor; // eslint-disable-line no-param-reassign
          shape.style.strokeWidth = 5; // eslint-disable-line no-param-reassign
        });
      });

      if(
        (this.hasSegmentPermission && segmentCategory === 'Segment') ||
        (this.hasTurnRestrictionPermission && segmentCategory === 'Maneuver') ||
        (this.hasGeometryPermission && segmentCategory === 'Geometry')
      ) {
        IWEventManager.addCustomListener(polyline, 'ondblclick', (event) => {
          this.prepareEditSegment(segment);
        });
      }
    }

    if (doRender) {
      map.renderer.render();
    }
  }

  startResize(circle, map, segment) {

    let newPosition = new IWPoint();
    let circlePosition = new IWPoint();

    const offset = IWDOMHelper.getElementOffset(map.map.getContainer());

    IWEventManager.addDomListener(window, 'mousemove', (event) => {
      newPosition.setX(event.x);
      newPosition.setY(event.y);

      circlePosition.setX(offset.x + circle.coordPX.getX());
      circlePosition.setY(offset.y + circle.coordPX.getY());

      let distance = newPosition.distanceFrom(circlePosition);
      circle.radius = distance*map.map.getMeterPerPixel();

      $('#depotRadius').val(Math.round(circle.radius));
      segment.attributes.Radius = Math.round(circle.radius);
      map.renderer.render();
    })
  }

  drawMarker(segment, map, addToList) {
    let markers = [];

    if(segment.type === constants.SEGMENT_TYPE_CUT_POINT) {
      let marker = this.drawCutPointMarker(
        map,
        segment.coordinates[0],
        segment
      );
      markers.push(marker);
      return markers;
    }

    if(segment.type === constants.SEGMENT_TYPE_GEOFENCE) {
      let marker = this.drawDepotCarMarker(map, segment.coordinates[0], parseInt(segment.attributes.Angle), segment);
      markers.push(marker);
      return markers;
    }

    let restrictionString = this.parseTruckAttributesForm();
    let hasTruckAttributes = (segment.hasOwnProperty.call(segment._attributes, 'ovld_TA') && segment._attributes.ovld_TA !== '')
      || (segment._attributes.modified_street && segment._attributes.modified_street.TA && segment._attributes.modified_street.TA !== '');

    if((hasTruckAttributes  || restrictionString !== '') && segment.type !== constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL) {
      let attributes;
      // "addToList" means the segment is drawn on the normal map: it already exists -> if false, its drawn as the preview in the mini-map
      if(hasTruckAttributes && addToList) {

        if(segment.hasOwnProperty.call(segment._attributes, 'ovld_TA')) {
          attributes = this.parseRestrictionString(segment.getAttributeByName('ovld_TA'));
        } else {
          attributes = this.parseRestrictionString(segment.getAttributeByName('modified_street').TA);
        }
      } else {
        attributes = this.parseRestrictionString(restrictionString);
      }

      let mercCoord = segment.coordinates.map(coord => coord.toMercator());

      let centerCoordinate = this.iwTruckAttributes.getCenter(mercCoord);
      let marker = this.iwTruckAttributes.createMarker(attributes, centerCoordinate);

      if(!!marker) {
        marker._map = map.map;
        //$(marker.getContainer()).addClass('segmentDirectionArrow');
        map.map.getOverlayManager().getLayer(
          constants.SEGMENT_MARKERS_LAYER_ID,
        ).addOverlay(marker);

        let hoverPolyline;

        IWEventManager.addCustomListener(marker, 'onclick', (e) => {
          if(event.ctrlKey || event.which !== 1) {
            return;
          }

          let balloonContainer = this.createTruckAttributesBalloon(attributes, true);

          if(
            (this.hasSegmentPermission && constants.SEGMENT_TYPE_TO_CATEGORY[segment.type] === "Segment") ||
            (this.hasGeometryPermission && constants.SEGMENT_TYPE_TO_CATEGORY[segment.type] === "Geometry")
          ) {
            balloonContainer.find('#truck-attribute-edit')
              .off()
              .on('click', () => {
                this.prepareEditSegment(segment)
              });
          } else {
            balloonContainer.find('#truck-attribute-options').addClass('d-none');
          }

          this._map.map.openInfoBalloon(marker._coordinate, balloonContainer.get(0));
        });

        IWEventManager.addCustomListener(marker, 'onmouseover', (e) => {
          this._map.map.openTooltip(centerCoordinate, this.iwTruckAttributes.createTooltipContent(attributes));
          hoverPolyline = this._map._renderer.drawPolyline(segment.coordinates, {
            stroke: 'blue',
            strokeWidth: 15
          });
          this._map._renderer.render();
        });

        IWEventManager.addCustomListener(marker, 'onmouseout', (e) => {
          this._map.map.removeTooltip();
          if(hoverPolyline) {
            this._map._renderer.removeElement(hoverPolyline)
          }
        });

        markers.push(marker);
      }
    } else if(segment._attributes.ovld_TA !== 'undefined' && segment._attributes.ovld_TA === '') {
      let mercCoord = segment.coordinates.map(coord => coord.toMercator());
      let centerCoordinate = this.iwTruckAttributes.getCenter(mercCoord);
      let marker = OpenFile.createRestrictionRemovedMarker(map, centerCoordinate);
      map.map.getOverlayManager().getLayer(
        constants.SEGMENT_MARKERS_LAYER_ID,
      ).addOverlay(marker);
      markers.push(marker);
    }

    let isExpired = false;

    if(segment.getAttributeByName("end") !== null && new Date(segment.getAttributeByName("end")).getTime() < Date.now() ) {
      isExpired = true;
    }

    let segmentType = segment.type;

    if(segmentType === constants.SEGMENT_TYPE_MODIFIED_SPEED) {
      const originalRoadSpeed = segment.getAttributeByName('detourEditor_originalRoadSpeed');
      const newSpeed = segment.getAttributeByName('NewSpeed');

      segmentType = parseInt(newSpeed) > parseInt(originalRoadSpeed) ? constants.SEGMENT_PRIORITIZE : constants.SEGMENT_PENALIZE;
    }

    if(parseInt(segment.getAttributeByName('direction'), 10) === constants.SEGMENT_DIRECTION_POSITIVE && segment.type !== constants.SEGMENT_TRUCK_ATTRIBUTES
      && segment.type !== constants.SEGMENT_TYPE_DELETED_ORIGINAL && segment.type !== constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL && segment.type !== constants.SEGMENT_TYPE_ADDED_MANEUVER) {

      markers.push(OpenFile.drawSegmentDirectionMarker(
        map,
        segment.coordinates[0],
        segmentType,
        isExpired
      ));
    } else if(parseInt(segment.getAttributeByName('direction'), 10) === constants.SEGMENT_DIRECTION_NEGATIVE && segment.type !== constants.SEGMENT_TRUCK_ATTRIBUTES
      && segment.type !== constants.SEGMENT_TYPE_DELETED_ORIGINAL && segment.type !== constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL && segment.type !== constants.SEGMENT_TYPE_ADDED_MANEUVER) {

      markers.push(OpenFile.drawSegmentDirectionMarker(
        map,
        segment.coordinates[segment.coordinates.length - 1],
        segmentType,
        isExpired
      ));

    } else if(parseInt(segment.getAttributeByName('direction'), 10) === constants.SEGMENT_DIRECTION_BOTH && segment.type !== constants.SEGMENT_TRUCK_ATTRIBUTES
      && segment.type !== constants.SEGMENT_TYPE_DELETED_ORIGINAL && segment.type !== constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL && segment.type !== constants.SEGMENT_TYPE_ADDED_MANEUVER) {

      markers.push(OpenFile.drawSegmentDirectionMarker(
        map,
        segment.coordinates[0],
        segmentType,
        isExpired
      ));

      markers.push(OpenFile.drawSegmentDirectionMarker(
        map,
        segment.coordinates[segment.coordinates.length - 1],
        segmentType,
        isExpired
      ));
    }

    if(segment.getAttributeByName('modified_street') && segment.getAttributeByName('modified_street').snapedStart && map.container === "#segment-minimap-modfiy-street") {

      OpenFile.drawStreetSnappedMarker(
        map,
        segment.coordinates[0],
        segment.getAttributeByName('modified_street').snapedStart === 'true'
      )
    }

    if(segment.getAttributeByName('modified_street') && segment.getAttributeByName('modified_street').snapedEnd && map.container === "#segment-minimap-modfiy-street") {

      OpenFile.drawStreetSnappedMarker(
        map,
        segment.coordinates[segment.coordinates.length - 1],
        segment.getAttributeByName('modified_street').snapedEnd === 'true'
      )
    }

    if(segment.getAttributeByName('modified_street') && (segment.getAttributeByName('modified_street').RS !== "0" || segment.getAttributeByName('detourEditor_TimeDomain'))) {

      let rsValue = segment.getAttributeByName('modified_street').RS;

      if(segment.getAttributeByName('RS_TD') && segment.getAttributeByName('RS_TD') !== '') {
        rsValue = segment.getAttributeByName('RS_TD').split('~')[0];
      }

      let hotspot = new window.IWPoint(0, 27);

      if(map.container !== "#segment-minimap-modfiy-street" || (!segment.getAttributeByName('modified_street').snapedEnd && !segment.getAttributeByName('modified_street').snapedStart)) {
        hotspot = new window.IWPoint(13, 13);
      }

      if(rsValue === "341") {
        markers.push(OpenFile.drawRestrictionMarker(
          map,
          segment.coordinates[0],
          hotspot
        ));
      } else if(rsValue === "682"){
        markers.push(OpenFile.drawRestrictionMarker(
          map,
          segment.coordinates[segment.coordinates.length - 1],
          hotspot
        ));
      } else if(rsValue === "1023") {
        markers.push(OpenFile.drawRestrictionMarker(
          map,
          segment.coordinates[0],
          hotspot
        ));

        markers.push(OpenFile.drawRestrictionMarker(
          map,
          segment.coordinates[segment.coordinates.length - 1],
          hotspot
        ));
      }
    }

    return markers;
  }

  drawManeuver(maneuver, map) {
    let coordinates = maneuver.attributes.detourEditor_turnArrowCoords;

    if(!maneuver.attributes.detourEditor_hasArrowSet) {
      coordinates = this._turnRestrictions.maneuvers._extendCoordinates(coordinates);
      coordinates = this._turnRestrictions.maneuvers._addArrows(coordinates);
      maneuver.attributes.detourEditor_hasArrowSet = true;
    }

    let color = maneuver.attributes.detourEditor_editedOriginal ? '#2da7e3' : '#CD9B9B';

    const polyline = map.renderer.drawPolyline(
      coordinates,
      {
        stroke: color,
        strokeWidth: 5,
        strokeOpacity: 1,
      },
    );

    return polyline;
  }

  matchSegment(coordinates, fromTruckAttributes) {
    this._preloader.showCursorPreloader();

    const finishMatching = () => {
      if(!fromTruckAttributes) {
        this._segmentDrawer.clearDots();
        this.resetTruckAttributeModal();
      }

      this._preloader.hideCursorPreloader();
    };

    this._api.matchSegment(this._sessionId, new Segment(null, coordinates), this._file.id)
      .then((segment) => {
        this._latestSegment = segment;
        if(fromTruckAttributes) {
          this._latestSegment._attributes.detourEditor_originalTruckAttributes = this.createRestrictionStringFromMarker(this._latestEditedTruckAttributes);
          this._latestSegment._attributes.TimeDomain = this._latestTruckAttributesTimeDomain;
        }
        finishMatching();
        this.showAddSegmentForm();
      })
      .catch((error) => {
        console.error(error);
        Ui.showModalError(error.message);
        finishMatching();
      })
      .finally(() => {
        this._latestEditedTruckAttributes = null;
      });

  }

  matchDepotPoint(coordinates) {
    this._preloader.showCursorPreloader();

    const finishMatching = () => {
      this._segmentDrawer.clearDots();
      this._preloader.hideCursorPreloader();
    };

    if(coordinates.length === 1) {

      this._api.checkAddGeofence(this._sessionId, this._file.id, new Segment(null, coordinates))
        .then(segment => {
          segment.attributes.Angle = 0;
          segment.attributes.Radius = 20;
          segment.attributes.SegmentType = constants.SEGMENT_TYPE_GEOFENCE;
          segment.attributes.Function = "AdjustGpsAngle";

          finishMatching();
          this.showCreateDepotModal(segment, null);
        })
        .catch((error) => {
          console.error(error);
          Ui.showModalError(error.message);
          finishMatching();
        })

    } else {
      const geofenceCoordinates = [coordinates[0]];
      const streetCoordinates = coordinates;

      const geofenceRequest = this._api.checkAddGeofence(this._sessionId, this._file.id, new Segment(null, geofenceCoordinates));
      const streetRequest = this._api.checkAddStreet(this._sessionId, this._file.id, new Segment(null, streetCoordinates));

      Promise.all([geofenceRequest, streetRequest])
        .then(result => {
          const geofenceSegment = result[0];
          const streetSegment = result[1];

          const bearing = streetSegment.coordinates[0].bearingFrom(streetSegment.coordinates[streetSegment.coordinates.length -1]);
          const distance = streetSegment.coordinates[0].distanceFrom(streetSegment.coordinates[1]);
          geofenceSegment.attributes.Angle = bearing;
          geofenceSegment.attributes.Radius = distance;
          geofenceSegment.attributes.SegmentType = constants.SEGMENT_TYPE_GEOFENCE;
          geofenceSegment.attributes.Function = "AdjustGpsAngle";

          streetSegment.attributes.modified_street.RS = "0";
          streetSegment.attributes.modified_street.RS_TD = "";
          streetSegment.attributes.modified_street.TA = "";
          streetSegment.attributes.modified_street.TYPE = "ICB";

          finishMatching();
          this.showCreateDepotModal(geofenceSegment, streetSegment);
        })
        .catch((error) => {
          console.error(error);
          Ui.showModalError(error.message);
          finishMatching();
        })
    }
  }

  matchGeometryChange(coordinates, oldSegment) {
    this._preloader.showCursorPreloader();

    const finishMatching = () => {
      this._segmentDrawer.clearDots();
      this._preloader.hideCursorPreloader();
      this.resetTruckAttributeModal();
    };

    this._api.checkAddStreet(this._sessionId, this._file.id, new Segment(null, coordinates))
      .then((segment) => {
        this._latestSegment = segment;
        if(this._latestSegment._attributes.modified_street.TA !== '') {
          this._latestSegment._attributes.detourEditor_originalTruckAttributes = this._latestSegment._attributes.modified_street.TA;
        }

        if(oldSegment) {
          this._latestSegment._attributes.modified_street.MAP_TYPE = oldSegment._attributes.modified_street.MAP_TYPE;
          this._latestSegment._attributes.modified_street.NAME = oldSegment._attributes.modified_street.NAME;
          this._latestSegment._attributes.modified_street.RS = oldSegment._attributes.modified_street.RS;
          this._latestSegment._attributes.modified_street.TA = oldSegment._attributes.modified_street.TA;
          this._latestSegment._attributes.modified_street.TYPE = oldSegment._attributes.modified_street.TYPE;

          this._latestSegment._attributes.detourEditor_description = oldSegment._attributes.detourEditor_description;
          this.editGeometrySegment = oldSegment;
        }

        finishMatching();
        this.showModifyStreetForm(oldSegment);
      })
      .catch((error) => {
        console.error(error);
        Ui.showModalError(error.message);
        finishMatching();
      })
      .finally(() => {

      });
  }

  matchCutPoint(coordinates) {
    this._segmentDrawer.clearDots();
    this._api.checkDivideStreet(this._sessionId, this._file.id, coordinates[0])
      .then(res => {
        this._latestSegment = res;
        this.showCutPointForm();
      })
      .catch(err => {
        Ui.showModalError(err.message);
      });
  }

  showCutPointForm() {
    this.uiCreateCutPointModal.find('form')[0].reset();
    this.updateCutPointMap(this._latestSegment);
    this.uiCreateCutPointModal.modal('show');
  }

  showCreateDepotModal(geofenceSegment, streetSegment) {
    this.uiCreateDepotModal.find('form')[0].reset();
    this.uiCreateDepotModal.find('#createDepotFormHash').val('');
    this.uiCreateDepotModal.find('#createDepotFormDelete').hide();
    this.uiCreateDepotModal.find('#depot-modal-title-edit').addClass('d-none');
    this.uiCreateDepotModal.find('#depot-modal-title-create').removeClass('d-none');

    this.setDepotListeners(geofenceSegment, streetSegment);

    this.updateDepotMap(geofenceSegment, streetSegment, true);

    this._latestSegment = geofenceSegment;
    this._latestAdjacentSegment = streetSegment;
    this.uiCreateDepotModal.modal('show');
  }

  showModifyStreetForm(oldSegment) {
    this.uiModifyStreetModal.find('form')[0].reset();
    this.uiModifyStreetModal.find('#modifyStreetFormDelete').hide();
    this.uiModifyStreetModal.find('#attributeStreetName').val(this._latestSegment.attributes.modified_street.NAME);

    if(this.editGeometrySegment) {
      this.uiModifyStreetModal.find('#modifyStreetFormName').val(this._latestSegment._attributes.detourEditor_description);
      $('#modifyStreetFormSubmit').prop('disabled', false);
    }

    let rsValue = this._latestSegment.attributes.modified_street.RS;
    let mapTypeValue = this._latestSegment.attributes.modified_street.MAP_TYPE;

    if(rsValue < 341 &&  rsValue > 0) {
      rsValue = 341;
    } else if(rsValue < 682 && rsValue > 341) {
      rsValue = 682;
    } else if(rsValue < 1023 && rsValue > 682) {
      rsValue = 1023;
    }

    this._latestSegment.attributes.modified_street.RS = 0;

    this.setSegmentTypeListener(this._latestSegment);
    this.setRestoreAttributesListener(this._latestSegment);

    if(this._latestSegment.getAttributeByName('modified_street').TA && oldSegment) {
      this.fillTruckAttributesFormFromRestrictionString(this._latestSegment.getAttributeByName('modified_street').TA, true);
    }

    this.uiModifyStreetModal.find(`input[name=modifyStreetFormRestrictions][value="0"]`).prop('checked', true);

    this.updateGeometryMap(this._latestSegment);

    new SegmentTimeDomain(this._localization);

    this.uiModifyStreetModal.modal('show');
  }

  showAddSegmentForm() {
    this.uiCreateSegmentModal.find('#createSegmentFormDelete').hide();
    this.uiCreateSegmentModal.find('form')[0].reset();
    this.uiCreateSegmentForm.find('.type-toggle label').removeClass('active');
    this.uiCreateSegmentForm.find('#prioritySlider').val(10);
    this.uiCreateSegmentForm.find('#prioritySliderLabel').html(this._localization.translate('editor.priority-slider-title', {value: 10}));
    this.syncTruckAttributeInputs(true);

    // set Default direction to positive
    this._latestSegment.attributes.direction = constants.SEGMENT_DIRECTION_POSITIVE;
    this._latestSegment.type = constants.SEGMENT_TRUCK_ATTRIBUTES;

    this.uiCreateSegmentModal.find('#normal-routing-settings-cb').prop('checked', true);
    this.uiCreateSegmentModal.find('#emergency-routing-settings-cb').prop('checked', true);
    this.uiCreateSegmentModal.find('#emergency-routing-radius-cb').prop('checked', true);
    this.updateNormalRoutingLabel(true);
    this.updateEmergencyRoutingLabel(true);
    this.updateEmergencyRadiusLabel(true);

    const originalRoadSpeed = this._latestSegment.getAttributeByName('detourEditor_originalRoadSpeed');

    this.updateSegmentButtonModifySpeed(originalRoadSpeed, originalRoadSpeed);

    this.uiCreateSegmentModal.find('#createSegmentFormOriginalRoadSpeed').text(originalRoadSpeed + " km/h");
    this.uiCreateSegmentModal.find('#createSegmentNewRoadSpeed').val(originalRoadSpeed);
    this.uiCreateSegmentModal.find('#createSegmentRoadDelay').val(0);

    this.checkDirectionAndIntervalVisibility(this._latestSegment, this._latestSegment.type);
    // noinspection JSUnresolvedVariable
    this.setSegmentTypeListener(this._latestSegment);
    this.setRestoreAttributesListener(this._latestSegment);
    this.setEmergencySettingsListener();

    let turnRestrictionAvailable = !(!this._latestSegment.attributes.detourEditor_turnArrowCoords || this._latestSegment.attributes.detourEditor_turnArrowCoords.length <= 1);

    if(!this.hasSegmentPermission && !turnRestrictionAvailable) {
      Ui.showModalError(this._localization.translate('errors.turn-restriction-creation'));
      return;
    }

    if(!turnRestrictionAvailable || !this.hasTurnRestrictionPermission) {
      this.uiCreateSegmentModal.find('#segment-turnres-btn').addClass('d-none');
    } else {
      this.uiCreateSegmentModal.find('#segment-turnres-btn').removeClass('d-none');
    }

    if(!this.hasSegmentPermission) {
      this.uiCreateSegmentModal.find('#segment-closure-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-opening-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-prio-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-pen-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-delete-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-pen-prio-btn').addClass('d-none');

      this.uiCreateSegmentModal.find('#segment-turnres-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-turnres-btn').trigger('click');
    }

    this.updateModalMap(this._latestSegment);
    this._segmentInitialState = this._latestSegment.clone();

    new SegmentTimeDomain(this._localization, this._latestSegment);
    $('#deleteTimeEdits').trigger('click');

    this.uiCreateSegmentModal.modal('show');
  }

  finishAddSegment() {
    const hash = this.uiCreateSegmentModal.find('#createSegmentFormHash').val();
    let oldSegment = null;
    let attributes = {};

    if (hash) {
      oldSegment = this._file.getSegmentByHash(hash);
      attributes = $.extend(true,{},oldSegment.attributes);
      delete attributes.speed;
    } else {
      oldSegment = this._latestSegment;
    }

    let segmentType;
    if(isNaN(this.uiCreateSegmentModal.find('input[name="segment-type"]:checked').val(), 10)) {
      segmentType = constants.SEGMENT_TRUCK_ATTRIBUTES;
    } else {
      segmentType = constants.SEGMENT_TYPE_HTML_VALUE_TO_ATTRIBUTE_MAPPING[
        parseInt(this.uiCreateSegmentModal.find('input[name="segment-type"]:checked').val(), 10)
        ];
    }

    let truckAttributeString = this.parseTruckAttributesForm();

    if(this.uiCreateSegmentModal.find('#createSegmentFormName').val() !== '') {
      attributes.description = OpenFile.sanitize(this.uiCreateSegmentModal.find('#createSegmentFormName').val());
    } else {
      delete attributes.description;
    }

    //attributes.speed = this.uiCreateSegmentModal.find('#createSegmentFormSpeed').val();
    attributes.direction = this.uiCreateSegmentModal.find('input[name="createSegmentFormDirection"]:checked').val();

    let validityRouting = 0; // parseInt(this.uiCreateSegmentModal.find('#emergency-routing-settings').val());
    let validityRadius = 0; // parseInt(this.uiCreateSegmentModal.find('#emergency-routing-radius').val());
    let validityNormal = 0;

    const activeInEmerRouting = this.uiCreateSegmentModal.find('#emergency-routing-settings-cb').is(':checked');
    const activeInEmerRadius = this.uiCreateSegmentModal.find('#emergency-routing-radius-cb').is(':checked');
    const activeInRouting = this.uiCreateSegmentModal.find('#normal-routing-settings-cb').is(':checked');

    validityRouting = activeInEmerRouting ? 1 : 2;
    validityRadius = activeInEmerRadius ? 1 : 2;
    validityNormal = activeInRouting ? 1 : 2;

    attributes.validity =  validityRouting + (validityRadius*4) + (validityNormal*16);

    if(oldSegment.hasOwnProperty.call(oldSegment._attributes, constants.SEGMENT_ORIGINAL_ATTRIBUTES)) {
      attributes.detourEditor_originalTruckAttributes = oldSegment.getAttributeByName(constants.SEGMENT_ORIGINAL_ATTRIBUTES);
    }

    if(oldSegment.hasOwnProperty.call(oldSegment._attributes, 'detourEditor_turnArrowCoords') && segmentType === constants.SEGMENT_TYPE_ADDED_MANEUVER) {
      attributes.detourEditor_turnArrowCoords = oldSegment.getAttributeByName('detourEditor_turnArrowCoords');
      attributes.detourEditor_hasArrowSet = true;
    }

    if(oldSegment.hasOwnProperty.call(oldSegment._attributes, 'detourEditor_originalRoadSpeed')) {
      attributes.detourEditor_originalRoadSpeed = oldSegment.getAttributeByName('detourEditor_originalRoadSpeed');
    }

    if(truckAttributeString && truckAttributeString !== '') {
      attributes.ovld_TA = truckAttributeString;
    } else if((attributes.detourEditor_originalTruckAttributes && attributes.detourEditor_originalTruckAttributes !== '') || segmentType === constants.SEGMENT_TRUCK_ATTRIBUTES) {
      attributes.ovld_TA = '';
    } else {
      delete attributes.truckattributes;
      delete attributes.ovld_TA;
    }

    const segmentTimeFrameTimeDomain = $("#segmentTimeFrameTimeDomain").val();
    const segmentTimeFrameStartDate = $("#segmentTimeFrameStartDate").val();
    const segmentTimeFrameEndDate = $("#segmentTimeFrameEndDate").val();

    if(segmentTimeFrameTimeDomain !== "") {
      attributes.TimeDomain = segmentTimeFrameTimeDomain;
    }

    if(segmentTimeFrameStartDate !== "") {
      attributes.start = segmentTimeFrameStartDate;
    }

    if(segmentTimeFrameEndDate !== "") {
      attributes.end = segmentTimeFrameEndDate;
    }

    const segment = new Segment(
      oldSegment.id,
      oldSegment.coordinates,
      oldSegment.olr,
      attributes,
      constants.SEGMENT_NEW,
    );

    segment.type = segmentType;

    if(segment.type === constants.SEGMENT_UNBLOCK) {
      switch(attributes.direction) {
        case "1":
          segment._attributes.mod_restriction = 'oneway_pos';
          break;
        case "2":
          segment._attributes.mod_restriction = 'oneway_neg';
          break;
        case "3":
          segment._attributes.mod_restriction = 'unblock';
          break;
      }
    } else if(segment.type === constants.SEGMENT_CLOSE) {
      switch(attributes.direction) {
        case "1":
          segment._attributes.mod_restriction = 'block_pos';
          break;
        case "2":
          segment._attributes.mod_restriction = 'block_neg';
          break;
        case "3":
          segment._attributes.mod_restriction = 'block';
          break;
      }
    }

    if(segment.type === constants.SEGMENT_PENALIZE) {
      segment.attributes.priority = OpenFile.calculatePenalizeValue(this.uiCreateSegmentModal.find('#prioritySlider').val())
    } else if(segment.type === constants.SEGMENT_PRIORITIZE) {
      segment.attributes.priority = OpenFile.calculatePriorityValue(this.uiCreateSegmentModal.find('#prioritySlider').val())
    } else if(segment.type === constants.SEGMENT_TYPE_MODIFIED_SPEED) {
      segment.attributes.NewSpeed = this.uiCreateSegmentModal.find('#createSegmentNewRoadSpeed').val();
      segment.attributes.Delay = this.uiCreateSegmentModal.find('#createSegmentRoadDelay').val();
    }

    // Stop if nothing changed
    if (hash && segment.getIsAttributesEqualTo(this._segmentInitialState.attributes)) {
      this.resetTruckAttributeModal();
      this.updateSaveBadge();
      this._map.map.removeInfoBalloon();
      this.uiCreateSegmentModal.modal('hide');
      return;
    }

    const currentDate = new Date().toISOString();

    if (segment.id) {
      segment.flag = constants.SEGMENT_EDITED;
    }

    if (hash) {
      if (Object.prototype.hasOwnProperty.call(oldSegment.attributes, 'created')) {
        segment.attributes.detourEditor_created = oldSegment.attributes.created;
      } else if(Object.prototype.hasOwnProperty.call(oldSegment.attributes, 'detourEditor_created')) {
        segment.attributes.detourEditor_created = oldSegment.attributes.detourEditor_created;
      } else {
        segment.attributes.detourEditor_created = '';
      }
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.user._username;
      this._file.replaceSegment(oldSegment, segment);

      this.clearDrawnSegment(segment);
      this.drawSegment(this._map, segment, true, true, true);

      //this.drawOnMap(false);
      Ui.updateSegmentListRow(segment, this._localization);
    } else {
      segment.attributes.MapVersion = this.currentBuildVersion;
      segment.attributes.detourEditor_created = currentDate;
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.user._username;
      this.drawSegment(this._map, segment, true, true, true);
      this._file.addSegment(segment);
      Ui.addSegmentListRow(segment, this._localization);
    }

    this.resetTruckAttributeModal();

    this.updateSaveBadge();
    this._map.map.removeInfoBalloon();
    this.uiCreateSegmentModal.modal('hide');
  }

  finishAddDepot() {
    const hash = this.uiCreateDepotModal.find('#createDepotFormHash').val();
    let oldSegment = null;
    let attributes = {};

    if(hash) {
      oldSegment = this._file.getSegmentByHash(hash);
      attributes = $.extend(true,{},oldSegment.attributes);
    } else {
      oldSegment = this._latestSegment;
    }

    attributes.detourEditor_description = this.uiCreateDepotModal.find('#createDepotFormName').val();
    attributes.Radius = this.uiCreateDepotModal.find('#depotRadius').val();
    attributes.Angle = this.uiCreateDepotModal.find('#depotAngle').val();
    attributes.Function = "AdjustGpsAngle";
    attributes.SegmentType = constants.SEGMENT_TYPE_GEOFENCE;

    const segment = new Segment(
      oldSegment.id,
      oldSegment.coordinates,
      oldSegment.olr,
      attributes,
      constants.SEGMENT_NEW,
    );

    const currentDate = new Date().toISOString();

    if (segment.id) {
      segment.flag = constants.SEGMENT_EDITED;
    }

    if (hash) {
      if (Object.prototype.hasOwnProperty.call(oldSegment.attributes, 'created')) {
        segment.attributes.detourEditor_created = oldSegment.attributes.created;
      } else if(Object.prototype.hasOwnProperty.call(oldSegment.attributes, 'detourEditor_created')) {
        segment.attributes.detourEditor_created = oldSegment.attributes.detourEditor_created;
      } else {
        segment.attributes.detourEditor_created = currentDate;
      }
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.user._username;
      this._file.replaceSegment(oldSegment, segment);
      this.clearDrawnSegment(segment);
      this.drawSegment(this._map, segment, true, true, true);
      Ui.updateSegmentListRow(segment, this._localization);
    } else {
      segment.attributes.detourEditor_created = currentDate;
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.user._username;
      segment.type = constants.SEGMENT_TYPE_GEOFENCE;
      this.drawSegment(this._map, segment, true, true, true);
      this._file.addSegment(segment);
      Ui.addSegmentListRow(segment, this._localization);
    }

    if(this._latestAdjacentSegment) {

      this._latestAdjacentSegment.attributes.detourEditor_description = this.uiCreateDepotModal.find('#createDepotFormName').val();

      const streetSegment = new Segment(
        this._latestAdjacentSegment.id,
        this._latestAdjacentSegment.coordinates,
        this._latestAdjacentSegment.olr,
        this._latestAdjacentSegment.attributes,
        constants.SEGMENT_NEW
      );

      streetSegment.attributes.detourEditor_created = currentDate;
      streetSegment.attributes.detourEditor_modified = currentDate;
      streetSegment.attributes.detourEditor_modifiedBy = this.user._username;
      this.drawSegment(this._map, streetSegment, true, true, true);
      this._file.addSegment(streetSegment);
      Ui.addSegmentListRow(streetSegment, this._localization);
    }

    this._latestAdjacentSegment = null;
    this.updateSaveBadge();
    this._map.map.removeInfoBalloon();
    this.uiCreateDepotModal.modal('hide');
  }

  finishAddStreetSegment() {
    const hash = this.uiModifyStreetModal.find('#modifyStreetFormHash').val();
    let oldSegment = null;
    let attributes = {};
    attributes.modified_street = {};
    if (hash) {
      oldSegment = this._file.getSegmentByHash(hash);
      attributes = $.extend(true,{},oldSegment.attributes);
    } else {
      oldSegment = this._latestSegment;
    }

    attributes.modified_street.TA = this.parseTruckAttributesForm(true);

    if(attributes.detourEditor_TimeDomain) {
      attributes.modified_street.RS = 0;
      attributes.RS_TD = this.uiModifyStreetModal.find(`input[name=modifyStreetFormRestrictions]:checked`).val() + '~' + attributes.detourEditor_TimeDomain;
    } else {
      attributes.modified_street.RS = this.uiModifyStreetModal.find(`input[name=modifyStreetFormRestrictions]:checked`).val();
    }

    attributes.modified_street.MAP_TYPE = 2;
    attributes.modified_street.NAME = this.uiModifyStreetModal.find('#attributeStreetName').val();
    attributes.modified_street.TYPE = constants.MAP_TYPE_TO_TYPE_MAPPING[attributes.modified_street.MAP_TYPE];
    attributes.detourEditor_description = OpenFile.sanitize(this.uiModifyStreetModal.find('#modifyStreetFormName').val());

    if(oldSegment.hasOwnProperty.call(oldSegment._attributes, constants.SEGMENT_ORIGINAL_ATTRIBUTES)) {
      attributes.detourEditor_originalTruckAttributes = oldSegment.getAttributeByName(constants.SEGMENT_ORIGINAL_ATTRIBUTES);
    }

    const segment = new Segment(
      oldSegment.id,
      oldSegment.coordinates,
      oldSegment.olr,
      attributes,
      constants.SEGMENT_NEW,
    );

    // Stop if nothing changed
    if (hash && segment.getIsModifiedStreetAttributesEqualTo(oldSegment.attributes.modified_street)) {
      return;
    }

    const currentDate = new Date().toISOString();

    if(this.editGeometrySegment) {
      this.deleteSegment(this.editGeometrySegment);
    }

    if (segment.id) {
      segment.flag = constants.SEGMENT_EDITED;
    }

    if (hash) {
      if (Object.prototype.hasOwnProperty.call(oldSegment.attributes, 'created')) {
        segment.attributes.detourEditor_created = oldSegment.attributes.created;
      } else if(Object.prototype.hasOwnProperty.call(oldSegment.attributes, 'detourEditor_created')) {
        segment.attributes.detourEditor_created = oldSegment.attributes.detourEditor_created;
      } else {
        segment.attributes.detourEditor_created = currentDate;
      }
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.user._username;
      this._file.replaceSegment(oldSegment, segment);
      this.clearDrawnSegment(segment);
      this.drawSegment(this._map, segment, true, true, true);
      Ui.updateSegmentListRow(segment, this._localization);
    } else {
      segment.attributes.detourEditor_created = currentDate;
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.user._username;
      segment.type = constants.SEGMENT_MODIFIED_STREET;
      this.drawSegment(this._map, segment, true, true, true);
      this._file.addSegment(segment);
      Ui.addSegmentListRow(segment, this._localization);
    }

    this.resetTruckAttributeModal();
    //this.drawOnMap(false);
    //this.updateSegmentList();
    this.updateSaveBadge();
    this._map.map.removeInfoBalloon();
    this.editGeometrySegment = null;
    this.uiModifyStreetModal.modal('hide');
  }

  finishCutStreet() {
    this._preloader.showCursorPreloader();

    this._latestSegment.attributes.detourEditor_description = $('#createCutPointFormName').val();
    const currentDate = new Date().toISOString();
    this._latestSegment.attributes.detourEditor_created = currentDate;
    this._latestSegment.attributes.detourEditor_modified = currentDate;
    this._latestSegment.attributes.detourEditor_modifiedBy = this.user._username;

    this._api.divideStreet(this._sessionId, this._file.id, this._latestSegment)
      .then(res => {
        this.uiCreateCutPointModal.modal('hide');
        this.reloadFile().then(() => {
          this._caretaker.reset();
          this._caretaker.add(this._file.serialize());
          this._turnRestrictions.draw();

          setTimeout(() => {
            if(this._file) {
              this._map.map.refreshTiles();
              this._minimap.map.refreshTiles();
              this._geometryMinimap.map.refreshTiles();
            }
          }, 2000);
        });
      })
      .catch(err => {
        this.uiCreateCutPointModal.modal('hide');
        Ui.showModalError(err.message);
      })
      .finally(() => {
        this._preloader.hideCursorPreloader()
      });
  }

  cancelAddSegment() {
    this._latestSegment = null;
    this.uiCreateSegmentModal.find('#createSegmentFormHash').val('');
    this._map.map.removeInfoBalloon();
    this.editGeometrySegment = null;
    this.resetTruckAttributeModal();
  }

  cancelAddStreetSegment() {
    this._latestSegment = null;
    this.uiModifyStreetModal.find('#modifyStreetFormHash').val('');
    this._map.map.removeInfoBalloon();
    this.editGeometrySegment = null;
    this.resetTruckAttributeModal();
  }

  prepareMatchSegment(position, coordinates, editType, oldSegment) {

    this.hasReachedDetourLimit()
      .then(result => {
        if(result) {
          this._segmentDrawer.clearDots();
          this.uiLimitReachModal.modal('show');
        } else {
          if(editType === constants.DRAWING_TYPE_GEOMETRY) {
            this.matchGeometryChange(coordinates, oldSegment)
          } else if(editType === constants.DRAWING_TYPE_SEGMENT) {
            this.matchSegment(coordinates, false)
          } else if(editType === constants.DRAWING_TYPE_CUT) {
            this.matchCutPoint(coordinates);
          } else if(editType === constants.DRAWING_TYPE_DEPOT) {
            this.matchDepotPoint(coordinates);
          }
        }
      });

    /*
    this._storage.getOption(constants.DETOUR_LIMIT)
      .then((result) => {
        if(result && result <= this.checkTotalChangesInFile()) {
          this._segmentDrawer.clearDots();
          this.uiLimitReachModal.modal('show');
        } else {
          if(editType === constants.DRAWING_TYPE_GEOMETRY) {
            this.matchGeometryChange(coordinates, oldSegment)
          } else if(editType === constants.DRAWING_TYPE_SEGMENT) {
            this.matchSegment(coordinates, false)
          } else if(editType === constants.DRAWING_TYPE_CUT) {
            this.matchCutPoint(coordinates);
          }
        }
      });
      */


  }

  showSegmentListContextMenu(position, segment) {
    const buttonZoom = this.uiSegmentListContextMenu.find('#editor-context-menu-zoom');
    const buttonSave = this.uiSegmentListContextMenu.find('#editor-context-menu-save');
    const buttonEdit = this.uiSegmentListContextMenu.find('#editor-context-menu-load');
    const buttonDelete = this.uiSegmentListContextMenu.find('#editor-context-menu-delete');
    const buttonUndo = this.uiSegmentListContextMenu.find('#editor-context-menu-undo');
    // Set the menu title
    this.uiSegmentListContextMenu.find('#segmentlist-row-context-menu-name').html(
      segment.getAttributeByName('description'),
    );

    const segmentCategory = constants.SEGMENT_TYPE_TO_CATEGORY[segment.type];

    switch (segment.flag) {
      case constants.SEGMENT_PUBLISHED:
      default:
        buttonSave.hide();
        buttonUndo.hide();
        buttonZoom.show();
        buttonEdit.show();
        buttonDelete.show();
        break;
      case constants.SEGMENT_NEW:
        buttonSave.show();
        buttonUndo.hide();
        buttonZoom.show();
        buttonEdit.show();
        buttonDelete.show();
        break;
      case constants.SEGMENT_EDITED:
        buttonSave.show();
        buttonUndo.hide();
        buttonZoom.show();
        buttonEdit.show();
        buttonDelete.show();
        break;
      case constants.SEGMENT_DELETED:
        buttonSave.show();
        buttonUndo.show();
        buttonZoom.hide();
        buttonEdit.hide();
        buttonDelete.hide();
        break;
    }

    if(segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
      buttonDelete.hide();
    }

    if(segment.type === constants.SEGMENT_TYPE_CUT_POINT) {
      buttonSave.hide();
      buttonUndo.hide();
      buttonEdit.hide();
    }

    if(segment.type === constants.SEGMENT_TURN_RESTRICTION) {
      buttonEdit.hide();
    }

    if(
      (!this.hasSegmentPermission && segmentCategory === 'Segment') ||
      (!this.hasTurnRestrictionPermission && segmentCategory === 'Maneuver') ||
      (!this.hasGeometryPermission && segmentCategory === 'Geometry')
    ) {
      buttonSave.hide();
      buttonUndo.hide();
      buttonEdit.hide();
      buttonDelete.hide();
    }

    buttonSave.off('click');
    // noinspection JSUnresolvedFunction
    buttonSave.on('click', () => {
      this.saveSegment(segment, false);
    });

    buttonZoom.off('click');
    // noinspection JSUnresolvedFunction
    buttonZoom.on('click', () => {
      this.zoomToSegment(segment);
    });

    buttonEdit.off('click');
    // noinspection JSUnresolvedFunction
    buttonEdit.on('click', () => {
      this.prepareEditSegment(segment);
    });

    buttonUndo.off('click');
    // noinspection JSUnresolvedFunction
    buttonUndo.on('click', () => {
      this.undoSegment(segment);
    });

    buttonDelete.off('click');
    // noinspection JSUnresolvedFunction
    buttonDelete.on('click', () => {
      this.deleteSegment(segment);
    });

    this.uiSegmentListContextMenu.css(position).show();
  }

  prepareEditSegment(segment) {
    if(segment.type === constants.SEGMENT_MODIFIED_STREET || segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
      this.editModifyStreetSegment(segment);
    } else if(segment.type === constants.SEGMENT_TYPE_GEOFENCE) {
      this.editDepotSegment(segment);
    } else if(segment.attributes.detourEditor_editedOriginal) {
      this._turnRestrictions.showEditTurnRestrictionModal(null, segment, null);
    } else {

      if(segment.getAttributeByName('detourEditor_originalRoadSpeed')) {
        this.editSegment(segment);
      } else {
        this._api.getAverageSpeedByPolyline(segment.coordinatesString, this._file.id, this._sessionId)
          .then(avgSpeed => {
            segment.attributes.detourEditor_originalRoadSpeed = avgSpeed;

            if(segment.getAttributeByName('priority')) {
              segment.attributes.NewSpeed = Math.round(avgSpeed * segment.attributes.priority);
            }

            this.editSegment(segment);
          })
      }
    }
  }

  editDepotSegment(segment) {
    this._currentEditedSegment = segment;
    this.uiCreateDepotModal.find('form')[0].reset();
    this.uiCreateDepotModal.find('#createDepotFormHash').val(this._currentEditedSegment.hash);
    this.uiCreateDepotModal.find('#createDepotFormName').val(this._currentEditedSegment.getAttributeByName('detourEditor_description'));
    this.uiCreateDepotModal.find('#depotRadius').val(this._currentEditedSegment.attributes.Radius);
    this.uiCreateDepotModal.find('#depotAngle').val(this._currentEditedSegment.attributes.Angle);
    this.uiCreateDepotModal.find('#depot-modal-title-edit').removeClass('d-none');
    this.uiCreateDepotModal.find('#depot-modal-title-create').addClass('d-none');

    this.uiCreateDepotModal.find('#createDepotFormDelete').show();

    this.setDepotListeners(this._currentEditedSegment);

    this.updateDepotMap(this._currentEditedSegment, null,true);
    this._segmentInitialState = segment.clone();
    this.uiCreateDepotModal.modal('show');
  }

  editModifyStreetSegment(segment) {
    this.uiModifyStreetModal.find('form')[0].reset();
    this.uiModifyStreetModal.find('#modifyStreetFormName').val(segment.getAttributeByName('detourEditor_description'));
    this.uiModifyStreetModal.find('#modifyStreetFormHash').val(segment.hash);
    this.uiModifyStreetModal.find('#attributeStreetName').val(segment.getAttributeByName('modified_street').NAME);

    let restrictionValue = segment.getAttributeByName('modified_street').RS;

    if(segment.getAttributeByName('RS_TD') && segment.getAttributeByName('RS_TD') !== '') {
      restrictionValue = segment.getAttributeByName('RS_TD').split('~')[0];
    }

    if(segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
      this.uiModifyStreetModal.find('#modifyStreetFromEditGeometry').addClass('d-none');
      this.uiModifyStreetModal.find('#modifyStreetFormDelete').addClass('d-none');
    } else {
      this.uiModifyStreetModal.find('#modifyStreetFromEditGeometry').removeClass('d-none');
      this.uiModifyStreetModal.find('#modifyStreetFormDelete').removeClass('d-none');
    }

    /*
    if(restrictionValue === "1023") {
      restrictionValue = 0;
    }
    */

    this.uiModifyStreetModal.find(`input[name=modifyStreetFormMapTypes][value="2"]`).prop('checked', true);
    this.uiModifyStreetModal.find(`input[name=modifyStreetFormRestrictions][value="${restrictionValue}"]`).prop('checked', true);
    this.resetTruckAttributeModal();

    if(segment.getAttributeByName('modified_street').TA) {
      this.fillTruckAttributesFormFromRestrictionString(segment.getAttributeByName('modified_street').TA, true);
    }

    this.setSegmentTypeListener(segment);
    new SegmentTimeDomain(this._localization, segment);

    if(this.uiModifyStreetModal.find('#modifyStreetFormName').val() !== '') {
      $('#modifyStreetFormSubmit').prop('disabled', false);
    }

    this.uiModifyStreetModal.find('#modifyStreetFormDelete').show().off('click.deletesegment').on('click.deletesegment', () => {
      this.deleteSegment(segment);
      this.uiModifyStreetModal.modal('hide');
    });

    this.uiModifyStreetModal.find('#modifyStreetFromEditGeometry').show().off('click.editsegment').on('click.editsegment', () => {

      this._segmentDrawer.initDrawSegmentFromSegment(segment);
      this.uiModifyStreetModal.modal('hide');
    });

    this.uiModifyStreetModal.find('#modifyStreetFormCancel').prop('disabled', false);
    this.updateGeometryMap(segment);
    this._segmentInitialState = segment.clone();
    this.uiModifyStreetModal.modal('show');
  }

  editSegment(segment) {
    this.uiCreateSegmentModal.find('form')[0].reset();
    this.uiCreateSegmentModal.find('#createSegmentFormName').val(segment.getAttributeByName('description'));
    this.uiCreateSegmentModal.find('#createSegmentFormHash').val(segment.hash);
    this.uiCreateSegmentModal.find('#createSegmentFormSpeed').val(segment.getAttributeByName('speed'));
    this.uiCreateSegmentModal.find(`input[name="createSegmentFormDirection"][value="${segment.getAttributeByName('direction')}"]`).prop('checked', true);

    let validity = segment.getAttributeByName('validity');

    const emergencyRoutingSettings = this.uiCreateSegmentModal.find('#emergency-routing-settings-cb');
    const emergencyRadiusSettings = this.uiCreateSegmentModal.find('#emergency-routing-radius-cb');
    const normalRoutingSettings = this.uiCreateSegmentModal.find('#normal-routing-settings-cb');

    const priority = segment.getAttributeByName('priority') ? segment.getAttributeByName('priority') : 1;

    const originalRoadSpeed = segment.getAttributeByName('detourEditor_originalRoadSpeed');
    const delay = segment.getAttributeByName('Delay') ? segment.getAttributeByName('Delay') : 0;

    const newSpeed = segment.getAttributeByName('NewSpeed') ? segment.getAttributeByName('NewSpeed') : originalRoadSpeed;

    this.uiCreateSegmentModal.find('#createSegmentFormOriginalRoadSpeed').text(originalRoadSpeed + " km/h");
    this.uiCreateSegmentModal.find('#createSegmentNewRoadSpeed').val(newSpeed);
    this.uiCreateSegmentModal.find('#createSegmentRoadDelay').val(delay);

    this.updateSegmentButtonModifySpeed(newSpeed, originalRoadSpeed);

    let segmentType = segment.type;

    if(segmentType === constants.SEGMENT_CLOSE && (segment.attributes.direction === "3" || segment.attributes.direction === 3)) {
      segmentType = 'closure-both';
    }

    if(segmentType === constants.SEGMENT_PENALIZE || segmentType === constants.SEGMENT_PRIORITIZE) {
      segment.type = constants.SEGMENT_TYPE_MODIFIED_SPEED;
      segment.hash = this.uiCreateSegmentModal.find('#createSegmentFormHash').val();
      segmentType = constants.SEGMENT_TYPE_MODIFIED_SPEED;
    }

    if(validity === constants.DEFAULT_VALIDITY[segmentType] || validity === "0" || validity === 0) {
      if(segment.type === constants.SEGMENT_CLOSE && segment.attributes.direction === "3" || segment.attributes.direction === 3) {
        emergencyRoutingSettings.prop('checked', false);
      } else {
        emergencyRoutingSettings.prop('checked', true);
      }
      emergencyRadiusSettings.prop('checked', constants.DEFAULT_EMERGENCY_RADIUS_SETTINGS[segmentType]);
      normalRoutingSettings.prop('checked', true);
    } else {
      let validityNormal = (validity >> 4) % 4;
      let validityRadius = (validity >> 2) % 4;
      let validityRouting = (validity >> 0) % 4;

      if(validityRouting === 0 || validityRouting === 1) {
        emergencyRoutingSettings.prop('checked', true);
      } else {
        emergencyRoutingSettings.prop('checked', false);
      }

      if(validityRadius === 0 && segment.type === constants.SEGMENT_CLOSE || validityRadius === 2) {
        emergencyRadiusSettings.prop('checked', false);
      } else {
        emergencyRadiusSettings.prop('checked', true);
      }

      normalRoutingSettings.prop('checked', (validityNormal === 0 || validityNormal === 1));
    }

    this.updateEmergencyRoutingLabel(emergencyRoutingSettings.is(':checked'));
    this.updateEmergencyRadiusLabel(emergencyRadiusSettings.is(':checked'));
    this.updateNormalRoutingLabel(normalRoutingSettings.is(':checked'));

    if(segment.type === constants.SEGMENT_PRIORITIZE) {
      let priorityFactor = OpenFile.calculatePriorityFactor(segment.getAttributeByName('priority'));
      this.uiCreateSegmentForm.find('#prioritySlider').val(priorityFactor);
      this.uiCreateSegmentForm.find('#prioritySliderLabel').html(this._localization.translate('editor.priority-slider-title', {value: priorityFactor}));
    } else if(segment.type === constants.SEGMENT_PENALIZE) {
      let penalizeFactor = OpenFile.calculatePenalizeFactor(segment.getAttributeByName('priority'));
      this.uiCreateSegmentForm.find('#prioritySlider').val(penalizeFactor);
      this.uiCreateSegmentForm.find('#prioritySliderLabel').html(this._localization.translate('editor.priority-slider-title', {value: penalizeFactor}));
    } else {
      this.uiCreateSegmentForm.find('#prioritySlider').val(10);
      this.uiCreateSegmentForm.find('#prioritySliderLabel').html(this._localization.translate('editor.priority-slider-title', {value: 10}));
    }

    this.resetTruckAttributeModal();

    if(segment.hasOwnProperty.call(segment.attributes, 'ovld_TA')) {
      this.fillTruckAttributesFormFromRestrictionString(segment.getAttributeByName('ovld_TA'));
    }

    this.uiCreateSegmentModal.find('#createSegmentFormDelete').show().off('click.deletesegment').on('click.deletesegment', () => {
      this.deleteSegment(segment);
      this.uiCreateSegmentModal.modal('hide');
    });

    this.checkDirectionAndIntervalVisibility(segment, segment.type);

    let turnRestrictionAvailable = !(!segment.attributes.detourEditor_turnArrowCoords || segment.attributes.detourEditor_turnArrowCoords.length <= 1);

    if(!turnRestrictionAvailable || !this.hasTurnRestrictionPermission) {
      this.uiCreateSegmentModal.find('#segment-turnres-btn').addClass('d-none');
    } else {
      this.uiCreateSegmentModal.find('#segment-turnres-btn').removeClass('d-none');
    }

    if(!this.hasSegmentPermission) {
      this.uiCreateSegmentModal.find('#segment-closure-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-opening-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-prio-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-pen-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-delete-btn').addClass('d-none');
      this.uiCreateSegmentModal.find('#segment-pen-prio-btn').addClass('d-none');

      this.uiCreateSegmentModal.find('#segment-turnres-btn').addClass('d-none');
    }

    const segmentTypeValue = constants.SEGMENT_TYPE_ATTRIBUTE_TO_HTML_VALUE_MAPPING[segment.type];
    this.uiCreateSegmentForm.find('.type-toggle label').removeClass('active');
    this.uiCreateSegmentModal.find(`input[name="segment-type"][value="${segmentTypeValue}"]`)
      .prop('checked', true)
      .parent().addClass('active');

    this.setSegmentTypeListener(segment);
    this.setRestoreAttributesListener(segment);
    this.setEmergencySettingsListener();

    new SegmentTimeDomain(this._localization, segment);

    this.uiCreateSegmentModal.find('#createSegmentFormSubmit').prop('disabled', false);
    this.updateModalMap(segment);
    this._segmentInitialState = segment.clone();
    this.uiCreateSegmentModal.modal('show');
  }

  setSegmentTypeListener(initialSegment) {
    const segment = initialSegment.clone();

    //const emergencyRoutingSettings = this.uiCreateSegmentModal.find('#emergency-routing-settings-cb');
    //const emergencyRadiusSettings = this.uiCreateSegmentModal.find('#emergency-routing-radius-cb');

    let activeSegmentType = "none";
    if(segment.id) {
      activeSegmentType = segment.type;
    }

    $('#attributeContainer :input')
      .off('change').on('change', () => {
        this.syncTruckAttributeInputs(false);
        this.checkDirectionAndIntervalVisibility(segment, activeSegmentType);
        this.updateModalMap(this._currentEditedSegment);
    });

    $('#attributeContainerModifyStreet :input')
      .off('change').on('change', () => {
      this.syncTruckAttributeInputs(false, true);
      this.checkDirectionAndIntervalVisibility(segment, activeSegmentType);
      this.updateModalMap(this._currentEditedSegment);
    });

    this.uiCreateSegmentTruckAttributeModal.find('input, select')
      .off('change').on('change', () => {
        this.syncTruckAttributeInputs(true);
        this.checkDirectionAndIntervalVisibility(segment, activeSegmentType);
        this.updateModalMap(this._currentEditedSegment);
    });

    this.uiCreateSegmentModal.find('.type-toggle label').off('click.segmenttype').on('click.segmenttype', (event) => {

      this.uiCreateSegmentModal.find('.type-toggle label').each(function(index) {
        $(this).removeClass("active");
        $(this).find('input').prop('checked', false);
      });


      const segmentType = constants.SEGMENT_TYPE_HTML_VALUE_TO_ATTRIBUTE_MAPPING[
        parseInt($(event.currentTarget).find('input').val(), 10)
      ];

      // "active" class appears a bit after the button has been clicked
      setTimeout(() => {
        if(activeSegmentType === segmentType) {
          $(event.currentTarget).removeClass("active");
          $(event.currentTarget).find('input').prop('checked', false)
          activeSegmentType = "none";
        } else {
          activeSegmentType = segmentType;
        }

        if(activeSegmentType === "none") {
          segment.type = constants.SEGMENT_TRUCK_ATTRIBUTES;

          delete segment.attributes.priority;

          const beginDate = this.uiCreateSegmentModal.find('#createSegmentFormBeginDateTime').val();
          const endDate = this.uiCreateSegmentModal.find('#createSegmentFormEndDateTime').val();

          if (beginDate) {
            segment.attributes.start = beginDate;
          }

          if (endDate) {
            segment.attributes.end = endDate;
          }

        } else if (activeSegmentType === constants.SEGMENT_CLOSE) {
          // eslint-disable-next-line no-param-reassign
          segment.type = constants.SEGMENT_CLOSE;

          delete segment.attributes.truckattributes;

          delete segment.attributes.priority;

          const beginDate = this.uiCreateSegmentModal.find('#createSegmentFormBeginDateTime').val();
          const endDate = this.uiCreateSegmentModal.find('#createSegmentFormEndDateTime').val();

          if (beginDate) {
            segment.attributes.start = beginDate;
          }

          if (endDate) {
            segment.attributes.end = endDate;
          }

        } else if (activeSegmentType === constants.SEGMENT_UNBLOCK) {
          // eslint-disable-next-line no-param-reassign
          segment.type = constants.SEGMENT_UNBLOCK;
          delete segment.attributes.start;
          delete segment.attributes.end;
          delete segment.attributes.priority;

        } else if(activeSegmentType === constants.SEGMENT_PENALIZE) {

          segment.type = constants.SEGMENT_PENALIZE;

          const beginDate = this.uiCreateSegmentModal.find('#createSegmentFormBeginDateTime').val();
          const endDate = this.uiCreateSegmentModal.find('#createSegmentFormEndDateTime').val();

          if (beginDate) {
            segment.attributes.start = beginDate;
          }

          if (endDate) {
            segment.attributes.end = endDate;
          }

        } else if(activeSegmentType === constants.SEGMENT_PRIORITIZE) {

          segment.type = constants.SEGMENT_PRIORITIZE;

          const beginDate = this.uiCreateSegmentModal.find('#createSegmentFormBeginDateTime').val();
          const endDate = this.uiCreateSegmentModal.find('#createSegmentFormEndDateTime').val();

          if (beginDate) {
            segment.attributes.start = beginDate;
          }

          if (endDate) {
            segment.attributes.end = endDate;
          }

        } else if(activeSegmentType === constants.SEGMENT_TYPE_MODIFIED_SPEED) {

          segment.type = constants.SEGMENT_TYPE_MODIFIED_SPEED;

          const beginDate = this.uiCreateSegmentModal.find('#createSegmentFormBeginDateTime').val();
          const endDate = this.uiCreateSegmentModal.find('#createSegmentFormEndDateTime').val();

          if (beginDate) {
            segment.attributes.start = beginDate;
          }

          if (endDate) {
            segment.attributes.end = endDate;
          }

          segment.attributes.NewSpeed = this.uiCreateSegmentModal.find('#createSegmentNewRoadSpeed').val();

        } else if(activeSegmentType === constants.SEGMENT_TYPE_DELETED_ORIGINAL || activeSegmentType === constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL) {
          segment.type = constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL;
          segment.attributes.SegmentType = constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL;
          delete segment.attributes.start;
          delete segment.attributes.end;
          delete segment.attributes.priority;
        } else if(activeSegmentType === constants.SEGMENT_TYPE_ADDED_MANEUVER) {
          segment.type = constants.SEGMENT_TYPE_ADDED_MANEUVER;
          segment.attributes.SegmentType = constants.SEGMENT_TYPE_ADDED_MANEUVER;
          delete segment.attributes.start;
          delete segment.attributes.end;
          delete segment.attributes.priority;

          /*
          emergencyRoutingSettings.prop('checked', true);
          emergencyRoutingSettings.trigger('change');
          emergencyRadiusSettings.prop('checked', false);
          emergencyRadiusSettings.trigger('change');
          */
        }

        this.checkDirectionAndIntervalVisibility(segment, activeSegmentType);

        this.updateModalMap(segment);
      }, 1);

    });
  }

  setDepotListeners(geofenceSegment, streetSegment) {
    $('#depotRadius').off().on('input', (event) => {

      let value =  $(event.currentTarget).val();

      if(value < 1) {
        value = 1;
        $(event.currentTarget).val(value);
      }

      geofenceSegment.attributes.Radius = $(event.currentTarget).val();
      this.updateDepotMap(geofenceSegment, streetSegment, false);
    });

    $('#depotAngle').off().on('input', (event) => {
      let value = $(event.currentTarget).val();

      if(value > 359) {
        value = 0;
        $(event.currentTarget).val(value);
      }
      if(value < 0) {
        value = 359;
        $(event.currentTarget).val(value);
      }

      geofenceSegment.attributes.Angle = value;
      this.updateDepotMap(geofenceSegment, streetSegment, false);
    });
  }

  setRestoreAttributesListener(segment) {
    this.uiCreateSegmentTruckAttributeModal.find('#truckAttributeSelectorRestoreDefault').off()
      .on('click', () => {
        if(segment.hasOwnProperty.call(segment._attributes, constants.SEGMENT_ORIGINAL_ATTRIBUTES)) {
          this.fillTruckAttributesFormFromRestrictionString(segment.getAttributeByName(constants.SEGMENT_ORIGINAL_ATTRIBUTES));
        } else {
          this.resetTruckAttributeModal();
        }
        this.updateModalMap(this._currentEditedSegment);
        this.syncTruckAttributeInputs(true);
      })
  }

  setEmergencySettingsListener() {
    const emergencyRoutingSettings = $('#emergency-routing-settings-cb');
    emergencyRoutingSettings.off().on("change", () => {
      let isChecked = emergencyRoutingSettings.is(':checked');
      this.updateEmergencyRoutingLabel(isChecked);
    });

    const emergencyRadiusSettings = $('#emergency-routing-radius-cb');
    emergencyRadiusSettings.off().on('change', () => {
      let isChecked = emergencyRadiusSettings.is(':checked');
      this.updateEmergencyRadiusLabel(isChecked);
    });

    const normalRoutingSettings = $('#normal-routing-settings-cb');
    normalRoutingSettings.off().on("change", () => {
      let isChecked = normalRoutingSettings.is(':checked');
      this.updateNormalRoutingLabel(isChecked)
    });
  }

  setEmergencySettingsTurnRestrictionListener() {
    const emergencyRoutingSettingsTr = $('#emergency-routing-settings-cb-tr');
    emergencyRoutingSettingsTr.off().on("change", () => {
      let isChecked = emergencyRoutingSettingsTr.is(':checked');
      this.updateEmergencyRoutingLabelTr(isChecked);
    });

    const emergencyRadiusSettingsTr = $('#emergency-routing-radius-cb-tr');
    emergencyRadiusSettingsTr.off().on('change', () => {
      let isChecked = emergencyRadiusSettingsTr.is(':checked');
      this.updateEmergencyRadiusLabelTr(isChecked);
    });

    const normalRoutingSettingsTr = $('#normal-routing-settings-cb-tr');
    normalRoutingSettingsTr.off().on("change", () => {
      let isChecked = normalRoutingSettingsTr.is(':checked');
      this.updateNormalRoutingLabelTr(isChecked)
    });
  }

  setDirectionListener() {
    const direction = this.uiCreateSegmentModal.find('input[name="createSegmentFormDirection"]');
    direction.off().on('change', (e) => {
      if(this.uiCreateSegmentModal.find('.type-toggle .active').find('input').val() === "0") {
        const emergencyRoutingSettings = this.uiCreateSegmentModal.find('#emergency-routing-settings-cb');
        const emergencyRadiusSettings = this.uiCreateSegmentModal.find('#emergency-routing-radius-cb');
        let direction = this.uiCreateSegmentModal.find('input[name="createSegmentFormDirection"]:checked').val();
        if(direction === "3") {
          emergencyRoutingSettings.prop('checked', false);
        } else {
          emergencyRoutingSettings.prop('checked', true);
        }
        emergencyRoutingSettings.trigger('change');
        emergencyRadiusSettings.prop('checked', false);
        emergencyRadiusSettings.trigger('change');
      }
    })
  }

  updateEmergencyRoutingLabel(isChecked) {
    const label = $('#emergency-routing-settings-label');
    if(isChecked) {
      label.text(this._localization.translate("general.yes"));
      label.data("translation-key", "general.yes");
    } else {
      label.text(this._localization.translate("general.no"));
      label.data("translation-key", "general.no");
    }
  }

  updateEmergencyRoutingLabelTr(isChecked) {
    const label = $('#emergency-routing-settings-label-tr');
    if(isChecked) {
      label.text(this._localization.translate("general.yes"));
      label.data("translation-key", "general.yes");
    } else {
      label.text(this._localization.translate("general.no"));
      label.data("translation-key", "general.no");
    }
  }

  updateEmergencyRadiusLabel(isChecked) {
    const label = $('#emergency-routing-radius-label');
    if(isChecked) {
      label.text(this._localization.translate("general.yes"));
      label.data("translation-key", "general.yes");
    } else {
      label.text(this._localization.translate("general.no"));
      label.data("translation-key", "general.no");
    }
  }

  updateEmergencyRadiusLabelTr(isChecked) {
    const label = $('#emergency-routing-radius-label-tr');
    if(isChecked) {
      label.text(this._localization.translate("general.yes"));
      label.data("translation-key", "general.yes");
    } else {
      label.text(this._localization.translate("general.no"));
      label.data("translation-key", "general.no");
    }
  }

  updateNormalRoutingLabel(isChecked) {
    const label = $('#normal-routing-settings-label');
    if(isChecked) {
      label.text(this._localization.translate("general.yes"));
      label.data("translation-key", "general.yes");
    } else {
      label.text(this._localization.translate("general.no"));
      label.data("translation-key", "general.no");
    }
  }

  updateNormalRoutingLabelTr(isChecked) {
    const label = $('#normal-routing-settings-label-tr');
    if(isChecked) {
      label.text(this._localization.translate("general.yes"));
      label.data("translation-key", "general.yes");
    } else {
      label.text(this._localization.translate("general.no"));
      label.data("translation-key", "general.no");
    }
  }

  updateSegmentButtonModifySpeed(newRoadSpeed, originalRoadSpeed) {
    if(parseInt(newRoadSpeed) > parseInt(originalRoadSpeed)) {
      this.uiCreateSegmentModal.find('#segment-pen-prio-btn').removeClass('btn-penalize').addClass('btn-primary');
    } else {
      this.uiCreateSegmentModal.find('#segment-pen-prio-btn').addClass('btn-penalize').removeClass('btn-primary');
    }
  }

  checkDirectionAndIntervalVisibility(segment, activeSegmentType) {
    this._currentEditedSegment = segment;
    let truckAttributeString = this.parseTruckAttributesForm();
    //const directionExplanationElement = $('#direction-explanation');

    const emerRoutingContainer = $('.emergency-routing-container');
    emerRoutingContainer.removeClass('d-none');

    if(activeSegmentType === constants.SEGMENT_TRUCK_ATTRIBUTES || activeSegmentType === "none") {
      $('.direction-picker').hide();
      $('.interval-pickers').show();
      $("#createSegmentFormDirectionBoth").trigger('click');
      segment.direction = constants.SEGMENT_DIRECTION_BOTH;
      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable-unblocked'));
      $('#priority-slider-container').addClass('d-none');
      $('#time-frame-container').removeClass('d-none');
      $('#truck-attributes-container').removeClass('d-none');
    } else if (activeSegmentType === constants.SEGMENT_CLOSE) {
      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable'));
      $('.interval-pickers, .direction-picker').show();
      $('#priority-slider-container').addClass('d-none');
      $('#time-frame-container').removeClass('d-none');
      $('#truck-attributes-container').removeClass('d-none');
    } else if (activeSegmentType === constants.SEGMENT_UNBLOCK) {
      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable-unblocked'));
      //segment.direction = constants.SEGMENT_DIRECTION_BOTH;
      $('.interval-pickers').hide();
      $('.direction-picker').show();
      $('#priority-slider-container').addClass('d-none');
      $('#time-frame-container').removeClass('d-none');
      $('#truck-attributes-container').removeClass('d-none');
    } else if(activeSegmentType === constants.SEGMENT_PENALIZE) {
      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable'));
      $('.interval-pickers, .direction-picker').show();
      $('#priority-slider-container').removeClass('d-none');
      $('#time-frame-container').removeClass('d-none');
      $('#truck-attributes-container').removeClass('d-none');
    } else if(activeSegmentType === constants.SEGMENT_PRIORITIZE) {
      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable'));
      $('.interval-pickers, .direction-picker').show();
      $('#priority-slider-container').removeClass('d-none');
      $('#time-frame-container').removeClass('d-none');
      $('#truck-attributes-container').removeClass('d-none');
    } else if(activeSegmentType === constants.SEGMENT_TYPE_DELETED_ORIGINAL || activeSegmentType === constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL) {
      $('.interval-pickers, .direction-picker').hide();
      $('#priority-slider-container').addClass('d-none');
      $('#time-frame-container').addClass('d-none');
      $('#truck-attributes-container').addClass('d-none');
      emerRoutingContainer.addClass('d-none');
      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable-unblocked'));
    } else if(activeSegmentType === constants.SEGMENT_TYPE_ADDED_MANEUVER) {
      $('.interval-pickers, .direction-picker').hide();
      $('#priority-slider-container').addClass('d-none');
      $('#time-frame-container').addClass('d-none');
      $('#truck-attributes-container').addClass('d-none');
    } else if(activeSegmentType === constants.SEGMENT_TYPE_MODIFIED_SPEED) {
      $('.interval-pickers').hide();
      $('.direction-picker').show();
      $('#priority-slider-container').removeClass('d-none');
      $('#time-frame-container').addClass('d-none');
      $('#truck-attributes-container').removeClass('d-none');
    }

    if(truckAttributeString !== '') {
      $('.direction-picker').hide();
      $('.interval-pickers').show();
      segment.direction = constants.SEGMENT_DIRECTION_BOTH;
      $("#createSegmentFormDirectionBoth").trigger('click');

      //directionExplanationElement.html(this._localization.translate('editor.direction-driveable-unblocked'));
    }
  }

  syncTruckAttributeInputs(editedInModal, syncWithGeometryForm) {

    if(editedInModal) {

      let width = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-width').val();
      let height = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-height').val();
      let weight = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-weight').val();

      $('#attributeInputWidthModifyStreet').val(width);
      $('#attributeInputHeightModifyStreet').val(height);
      $('#attributeInputWeightModifyStreet').val(weight);

      $('#attributeInputWidth').val(width);
      $('#attributeInputHeight').val(height);
      $('#attributeInputWeight').val(weight);

    } else {

      let currentWidth;
      let currentHeight;
      let currentWeight;

      if(syncWithGeometryForm) {

        currentWidth = $('#attributeInputWidthModifyStreet').val();
        currentHeight = $('#attributeInputHeightModifyStreet').val();
        currentWeight = $('#attributeInputWeightModifyStreet').val();

      } else {

        currentWidth = $('#attributeInputWidth').val();
        currentHeight = $('#attributeInputHeight').val();
        currentWeight = $('#attributeInputWeight').val();
      }

      this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-width').val(currentWidth);
      this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-height').val(currentHeight);
      this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-weight').val(currentWeight);
    }
  }

  updateModalMap(segment) {
    this._currentEditedSegment = segment;
    this._minimap.renderer.clearContainer();
    this._minimap.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._minimap.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this.drawSegment(this._minimap, segment, true, false);

    if(segment.attributes.detourEditor_hasArrowSet) {
      this._minimap.zoomToCoordinates(segment.attributes.detourEditor_turnArrowCoords, -1);
    } else {
      this._minimap.zoomToCoordinates(segment.coordinates, -1);
    }
  }

  updateGeometryMap(segment) {
    this._currentEditedSegment = segment;
    this._geometryMinimap.renderer.clearContainer();

    this._geometryMinimap.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._geometryMinimap.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this.drawSegment(this._geometryMinimap, segment, true, false);
    this._geometryMinimap.zoomToCoordinates(segment.coordinates, -1);
  }

  updateDepotMap(geofenceSegment, streetSegment, doZoom) {
    //this._currentEditedSegment = segment;
    this._depotMinimap.renderer.clearContainer();

    this._depotMinimap.map.getOverlayManager().getLayer(constants.SEGMENT_MARKERS_LAYER_ID).removeAllOverlays();
    this._depotMinimap.map.getOverlayManager().getLayer(constants.CUT_POINT_MARKERS_LAYER_ID).removeAllOverlays();

    this.drawSegment(this._depotMinimap, geofenceSegment, true, false);
    if(streetSegment) this.drawSegment(this._depotMinimap, streetSegment, true, false);

    if(doZoom) {
      if(streetSegment) {
        this._depotMinimap.zoomToCoordinates(streetSegment.coordinates, -1);
      } else {
        this._depotMinimap.zoomToCoordinates(geofenceSegment.coordinates, -3);
      }
      this._depotMinimap.switchBirdseyeView(true, false);
    }
  }

  updateCutPointMap(segment) {
    this._currentEditedSegment = segment;
    this._cutPointMinimap.renderer.clearContainer();

    this._cutPointMinimap.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._cutPointMinimap.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this.drawSegment(this._cutPointMinimap, segment, true, false);
    this._cutPointMinimap.map.setCenter(segment.coordinates[0], 17);
  }

  updateTurnRestrictionMap(segment) {
    this._currentEditedSegment = segment;
    this._editTurnRestrctionMinimap.renderer.clearContainer();

    this._editTurnRestrctionMinimap.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._editTurnRestrctionMinimap.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    if(!Array.isArray(segment.attributes.detourEditor_turnArrowCoords)) {
      segment.attributes.detourEditor_turnArrowCoords = this._api.stringToPolyline(segment.attributes.detourEditor_turnArrowCoords);
    }

    this.drawManeuver(segment, this._editTurnRestrctionMinimap);
    this._editTurnRestrctionMinimap.map.setCenter(segment.attributes.detourEditor_turnArrowCoords[0], 17);
    this._editTurnRestrctionMinimap.renderer.render();
  }

  /**
   *
   * @param {Segment} segment
   */
  deleteSegment(segment) {
    switch (segment.flag) {
      case constants.SEGMENT_NEW: {
        const question = this._localization.translate('editor.deletion-confirmation-warning4');
        Ui.showModalConfirmation(question, this._localization.translate('editor.confirm-deletion'), () => {
          Ui.removeSegmentListRow(segment, this._localization);
          this._file.removeSegmentByHash(segment.hash);
          //this.updateSegmentList();
          this.updateSaveBadge();
          this.clearDrawnSegment(segment);
          //this.drawOnMap(false);
        });

        break;
      }
      case constants.SEGMENT_PUBLISHED:
      default:
        this._file.markSegmentAsDeleted(segment.hash);
        Ui.updateSegmentListRow(segment, this._localization);
        //this.updateSegmentList();
        this.clearDrawnSegment(segment);
        this.updateSaveBadge();
        //this.drawOnMap(false);
        break;
    }
  }

  undoSegment(segment) {
    switch (segment.flag) {
      case constants.SEGMENT_DELETED: {
        const selectedSegment = this._file.getSegmentByHash(segment.hash);
        selectedSegment.flag = constants.SEGMENT_PUBLISHED;
        Ui.updateSegmentListRow(segment, this._localization);
        //this.updateSegmentList();
        this.updateSaveBadge();

        break;
      }
      default:
        // do nothing
        break;
    }

    this.drawOnMap(false);
  }

  updateSegmentList() {
    let currentPage = 0;
    if(window.dataTable){
      currentPage = window.dataTable.page();
    }

    return new Promise((resolve, reject) => {
      Ui.updateSegmentList(this._file.segments, this._localization, currentPage)
        .then((rows) => {
          // noinspection JSUnusedLocalSymbols
          rows.forEach(({ row, rowData, segment }) => { // eslint-disable-line no-unused-vars
            // noinspection JSUnresolvedFunction
            $(row)
              .on('contextmenu', (event) => {
                event.preventDefault();

                this.showSegmentListContextMenu(
                  { left: event.pageX, top: event.pageY }, segment,
                );
              })
              .on('dblclick', (event) => {
                event.preventDefault();
                this.zoomToSegment(segment);
              });
          });
          window.dataTable.page(currentPage).draw(false);
          resolve();
        })
        .catch((error) => {
          Ui.showModalError(localization.translate("errors.loading-segments"));
          console.error(error);
          reject(error);
        });
    });
  }

  saveSegment(segment, skipMapDraw) {
    this._preloader.showCursorPreloader();

    return new Promise((resolve, reject) => {
      let promise;

      switch (segment.flag) {
        case constants.SEGMENT_DELETED:
          if(segment.type === constants.SEGMENT_MODIFIED_STREET || segment.type === constants.SEGMENT_TYPE_CUT_POINT || segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET) {
            promise = this._api.deleteModifyStreetSegment(this._sessionId, this._file.id, segment);
          } else {
            promise = this._api.deleteSegment(this._sessionId, this._file.id, segment);
          }

          Promise.all([promise])
            .then(() => {
              this._file.removeSegmentByHash(segment.hash);
              Ui.removeSegmentListRow(segment, this._localization);
              //this.updateSegmentList();
              this.updateSaveBadge();
              this._preloader.hideCursorPreloader();
              if(!skipMapDraw) this.drawOnMap(false);
              resolve();
            })
            .catch((error) => {
              Ui.showModalError(error.message);
              console.error(error);
              reject(error);
              this._preloader.hideCursorPreloader();
            });

          break;
        case constants.SEGMENT_EDITED:

          if(segment.type === constants.SEGMENT_MODIFIED_STREET || segment.type === constants.SEGMENT_TYPE_CUT_POINT || segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
            promise = this._api.changeModifiedStreet(this._sessionId, this._file.id, segment);
          } else {
            promise = this._api.changeSegment(this._sessionId, this._file.id, segment);
          }

          Promise.all([promise])
            .then((newSegment) => {
              this._file.replaceSegment(segment, newSegment[0]);
              //this.updateSegmentList();
              Ui.updateSegmentListRow(newSegment[0], this._localization);
              this.updateSaveBadge();
              this._preloader.hideCursorPreloader();
              if(!skipMapDraw) this.drawOnMap(false);
              resolve();
            })
            .catch((error) => {
              Ui.showModalError(error.message);
              console.error(error);
              reject(error);
              this._preloader.hideCursorPreloader();
            });

          break;
        case constants.SEGMENT_NEW:
        default:

          if(segment.type === constants.SEGMENT_MODIFIED_STREET  || segment.type === constants.SEGMENT_TYPE_CUT_POINT || segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET) {
            promise = this._api.addStreet(this._sessionId, this._file.id, segment);
          } else if(segment.type === constants.SEGMENT_TYPE_GEOFENCE) {
            promise = this._api.addGeofence(this._sessionId, this._file.id, segment);
          } else {
            promise = this._api.addSegment(this._sessionId, this._file.id, segment, true);
          }

          Promise.all([promise])
            .then((newSegment) => {
              this._file.replaceSegment(segment, newSegment[0]);
              //this.updateSegmentList();
              Ui.updateSegmentListRow(newSegment[0], this._localization);
              this.updateSaveBadge();
              this._preloader.hideCursorPreloader();
              if(!skipMapDraw) this.drawOnMap(false);
              resolve();
            })
            .catch((error) => {
              Ui.showModalError(error.message);
              console.error(error);
              reject(error);
              this._preloader.hideCursorPreloader();
            });
          break;
      }
    });

  }

  /**
   *
   * @param {Segment} segment
   */
  zoomToSegment(segment) {
    let { coordinates } = segment;

    if (coordinates.length === 0 && segment.getAttributeByName('editor_coordinates') !== null) {
      coordinates = segment.getAttributeByName('editor_coordinates').split(';').map((coordinate) => {
        const coordinateTemp = coordinate.split(',');
        return new IWCoordinate(coordinateTemp[0], coordinateTemp[1], IWCoordinate.WGS84);
      });
    }

    if(coordinates.length === 0 && segment.getAttributeByName('detourEditor_turnArrowCoords') !== null) {
      coordinates = segment.getAttributeByName('detourEditor_turnArrowCoords');
    }

    let polyline = this._map.renderer.drawPolyline(segment.coordinates, {
      stroke: 'black',
      strokeWidth: 7
    });
    this._map.renderer.render();
    let interval = setInterval(() => {
      if ($(polyline.shapes)
        .is(':visible')) {
        $(polyline.shapes)
          .addClass('d-none');
      } else {
        $(polyline.shapes)
          .removeClass('d-none');
      }
    }, 150);
    setTimeout(() => {
      clearInterval(interval);
      this._map.renderer.removeElement(polyline);
    }, 1500);

    this._map.zoomToCoordinates(coordinates, -1);
    this.uiSegmentListModal.modal('hide');
  }

  saveAll() {
    const segments = this._file.segments.filter(
      segment => segment.flag !== constants.SEGMENT_PUBLISHED,
    );

    const changes = segments.map((segment) => {
      const name = segment.getAttributeByName('description') ? segment.getAttributeByName('description') : segment.getAttributeByName("detourEditor_description");
      switch (segment.flag) {
        case constants.SEGMENT_DELETED:
          return `<li>${name !== '' && name !== 'null' && name ? name : segment.id ? segment.id : ''} <span class="badge badge-danger">${this._localization.translate('editor.deleted')}</span></li>`;
        case constants.SEGMENT_EDITED:
          return `<li>${name !== '' && name !== 'null' && name ? name : segment.id ? segment.id : ''} <span class="badge badge-success">${this._localization.translate('editor.edited')}</span></li>`;
        case constants.SEGMENT_NEW:
        default:
          return `<li>${name !== '' && name !== 'null' && name ? name : segment.id ? segment.id : ''} <span class="badge badge-success">${this._localization.translate('editor.new')}</span></li>`;
      }
    });

    const question = `<h6>${this._localization.translate('editor.publish-confirmation-warning5')}</h6>
<ol>
    ${changes.join('')}
</ol>
`;
    Ui.showModalConfirmation(question, this._localization.translate('general.confirm-action'), async () => {

      if(segments.find(segment => segment.type === constants.SEGMENT_MODIFIED_STREET
        || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET
        || segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET
        || segment.type === constants.SEGMENT_TYPE_CUT_POINT
        || segment.type === constants.SEGMENT_TYPE_GEOFENCE)) {
        for (let segment of segments) {
          await this.saveSegment(segment, true)
        }

        this.reloadFile()
          .then(() => {
            this._caretaker.reset();
            this._caretaker.add(this._file.serialize());
            this._turnRestrictions.draw();

            setTimeout(() => {
              if(this._file) {
                this._map.map.refreshTiles();
                this._minimap.map.refreshTiles();
                this._geometryMinimap.map.refreshTiles();
              }
            }, 2000);
          });

      } else {
        const segmentsPromises = segments.map(async segment => await this.saveSegment(segment, true));

        Promise.all(segmentsPromises)
          .then(() => {
            this._caretaker.reset();
            this._caretaker.add(this._file.serialize());
            this._turnRestrictions.draw();

            /*
            segments.forEach(segment => {
              this.clearDrawnSegment(segment);
              this.drawSegment(this._map, segment, false, true, true);
            });
            */

            this.drawOnMap(false)
          });
      }

    });
  }

  download() {
    const blob = new Blob([this._file.serialize()], { type: 'text/json' });
    const filename = `${this._file.name}.json`;

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }

  parseTruckAttributesForm(fromGeometryModal) {
    let truckAttribute = {};

    if(this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-width').val() === '') {

      if(fromGeometryModal) {

        truckAttribute.width = this.uiModifyStreetModal.find('#attributeInputWidthModifyStreet').val()*100;
        truckAttribute.height = this.uiModifyStreetModal.find('#attributeInputHeightModifyStreet').val()*100;
        truckAttribute.weight = this.uiModifyStreetModal.find('#attributeInputWeightModifyStreet').val()*10;

      } else {

        truckAttribute.width = this.uiCreateSegmentForm.find('#attributeInputWidth').val()*100;
        truckAttribute.height = this.uiCreateSegmentForm.find('#attributeInputHeight').val()*100;
        truckAttribute.weight = this.uiCreateSegmentForm.find('#attributeInputWeight').val()*10;

      }

    } else {

      truckAttribute.width = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-width').val()*100;
      truckAttribute.height = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-height').val()*100;
      truckAttribute.weight = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-weight').val()*10;

    }

    truckAttribute.length = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-length').val()*100;
    truckAttribute.axleCount = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-axleCount').val();
    truckAttribute.axleWeight = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-axleWeight').val()*10;

    if(this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-hazardLoad').prop("checked")) truckAttribute.hazardLoad = '';
    if(this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-explosiveLoad').prop("checked")) truckAttribute.explosiveLoad = '';
    if(this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-harmfulLoad').prop("checked")) truckAttribute.harmfulLoad = '';

    /*
    truckAttribute.hazardLoad = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-hazardLoad').prop("checked") ? 1 : 0;
    truckAttribute.explosiveLoad = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-explosiveLoad').prop("checked") ? 1 : 0;
    truckAttribute.harmfulLoad = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-harmfulLoad').prop("checked") ? 1 : 0;
    */

    let tunnelCode = this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-tunnelcode').val();
    if(tunnelCode !== "") {
      truckAttribute[tunnelCode] = 0;
    }

    let restrictionString = "";
    for(const [key, value] of Object.entries(truckAttribute)) {
      let subString = "";
      if(['A', 'B', 'C', 'D', 'E'].includes(key)) {
        subString = `${constants.TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING[key]}~~1~~~1~~|`;
      } else if(value && value !== '') {
        subString = `${constants.TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING[key]}~~1~${Math.round(value)}~~~~|`;
      } else if(key === "hazardLoad" || key === "harmfulLoad" || key === "explosiveLoad") {
        subString = `${constants.TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING[key]}~~1~0~~~~|`;
      }
      restrictionString += subString;
    }
    restrictionString = restrictionString.slice(0, -1);

    return restrictionString;
  }

  createRestrictionStringFromMarker(attributes) {
    let restrictionString = "";

    attributes.forEach(attr => {
      let subString = `${constants.TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING[attr.RestrType]}~~1~${Math.round(attr.Value)}~~~~|`;
      restrictionString += subString;
    });

    restrictionString = restrictionString.slice(0, -1);

    return restrictionString;
  }

  fillTruckAttributesFormFromRestrictionString(restrictionString, syncWithGeometryForm) {
    let restrictions = restrictionString.split('|');

    this.resetTruckAttributeModal();

    restrictions.forEach(res => {

      let resSplit = res.split('~');

      let attribute = constants.TRUCK_ATTRIBUTE_VALUE_TO_TYPE_MAPPING[resSplit[0]];
      let value = resSplit[3];

      switch(parseInt(resSplit[0])) {
        case 0:
        case 1:
        case 2:
          this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-' + attribute).val(value/100);
          break;
        case 3:
          this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-weight').val(value/10);
          break;
        case 4:
          this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-axleWeight').val(value/10);
          break;
        case 33:
        case 34:
        case 35:
          this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-' + attribute).prop('checked', true);
          break;
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
          this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-tunnelcode').val(attribute);
          break;
        case 50:
          this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-axleCount').val(value);
          break;
        default:
          break;
      }
    });

    this.syncTruckAttributeInputs(true, syncWithGeometryForm);
  }

  fillTruckAttributesFormFromIWTruckAttribute(truckAttribute) {
    truckAttribute.forEach(attr => {

        let value = attr.Value;

        switch(constants.TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING[attr.RestrType]) {
          case 0:
          case 1:
          case 2:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-' + attr.RestrType).val(value/100);
            break;
          case 3:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-weight').val(value/10);
            break;
          case 4:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-axleWeight').val(value/10);
            break;
          case 33:
          case 34:
          case 35:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-' + attr.RestrType).prop('checked', true);
            break;
          case 36:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-hazardLoad').prop('checked', true);
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-explosiveLoad').prop('checked', true);
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-harmfulLoad').prop('checked', true);
            break;
          case 37:
          case 38:
          case 39:
          case 40:
          case 41:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-tunnelcode').val(attr.RestrType);
            break;
          case 50:
            this.uiCreateSegmentTruckAttributeModal.find('#truck-attribute-axleCount').val(value);
            break;
          default:
            break;
        }
    });

    this.syncTruckAttributeInputs(true);
  }

  parseRestrictionString(restrictionString) {

    let restrictions = restrictionString.split('|');

    let truckAttribute = [];

    restrictions.forEach(res => {

      let resSplit = res.split('~');

      let attribute = constants.TRUCK_ATTRIBUTE_VALUE_TO_TYPE_MAPPING[resSplit[0]];
      let value = resSplit[3];
      let unit = '';

      switch(constants.TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING[attribute]) {
        case 0:
        case 1:
        case 2:
          unit = 'cm';
          break;
        case 3:
        case 4:
          unit = '100 kg';
          break;
        default:
          break;
      }

      let attributeValue = {
        RestrType: attribute,
        Value: value,
        Unit: unit
      };

      truckAttribute.push(attributeValue);
    });

    return truckAttribute;
  }

  resetTruckAttributeModal() {

    this.uiCreateSegmentTruckAttributeModal.find('input').val('');
    this.uiCreateSegmentTruckAttributeModal.find('input').prop('checked', false);
    this.uiCreateSegmentTruckAttributeModal.find('select').val('');

    this.syncTruckAttributeInputs(true);
    this.syncTruckAttributeInputs(true, true);
  }

  createTruckAttributesBalloon(properties, createdByUser) {
    let balloonContainer = $('#truck-attribute-balloon-template').clone();
    balloonContainer.find('#truck-attribute-list').html('');

    let isSoftRestriction = false;
    let timeDomain = '';

    properties.forEach(prop => {
      if(prop.RestrType) {

        if(prop.Priority === "3") {
          isSoftRestriction = true;
        }

        if(prop.TimeDomain && prop.TimeDomain !== '') {
          timeDomain = prop.TimeDomain;
        }

        let translationKey = constants.TRUCK_ATTRIBUTE_TYPE_TO_TRANSLATION[prop.RestrType];
        let typeLabel;

        if(prop.Value && prop.Value !== '') {
          let value = prop.Value;

          if(prop.Unit) {
            value = value / constants.TRUCK_ATTRIBUTE_UNIT_CONVERSION_VALUES[prop.Unit];
          }

          typeLabel = $(`<label class='list-group-item' data-translation-key="${translationKey}">${this._localization.translate(translationKey, {value: value})}</label>`);

        } else {
          typeLabel = $(`<label class='list-group-item' data-translation-key="${translationKey}">${this._localization.translate(translationKey)}</label>`);
        }

        balloonContainer.find('#truck-attribute-list').append(typeLabel);
      }
    });

    if(timeDomain !== '') {
      let startDomainFull = SegmentTimeDomain.getTimeDomains(timeDomain);
      let durationFull = SegmentTimeDomain.getDurations(timeDomain);

      let hours = SegmentTimeDomain.matchGroups("hours", startDomainFull);
      let daysStrings = [];

      SegmentTimeDomain.matchGroups("weekly", startDomainFull).forEach(day => {

        day = parseInt(day.substring(1));
        let realDay = 0;
        if(day === 1) {
          realDay = 7;
        } else {
          realDay = day - 1;
        }

        switch(realDay) {
          case 1:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.monday'));
            break;
          case 2:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.tuesday'));
            break;
          case 3:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.wednesday'));
            break;
          case 4:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.thursday'));
            break;
          case 5:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.friday'));
            break;
          case 6:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.saturday'));
            break;
          case 7:
            daysStrings.push(this._localization.translate('editor.segmentTimeDomain.sunday'));
            break;
        }
      });

      let daysSingleString = '';
      daysStrings.forEach((day, i) => {
        daysSingleString += day;
        if((i+1) !== daysStrings.length) {
          daysSingleString += ', '
        }
      });

      let startDomain = parseInt(hours[0].substring(1));
      let duration = parseInt(durationFull[0].substring(1));

      let start = new Date();
      start.setHours(startDomain);
      start.setMinutes(0);
      start.setSeconds(0);
      let startString = start.toLocaleTimeString(undefined, {hour: 'numeric', minute: 'numeric'});

      let end = new Date();
      end.setHours(startDomain + duration);
      end.setMinutes(0);
      end.setSeconds(0);
      let endString = end.toLocaleTimeString(undefined, {hour: 'numeric', minute: 'numeric'});

      let timeWarningLabel = '';

      if(daysSingleString !== '') {
        timeWarningLabel = $(`<label class='list-group-item list-group-item-danger font-weight-bold' data-translation-key="editor.truck-attributes.time-domain-warning">${this._localization.translate("editor.truck-attributes.time-domain-warning-detailed-weekday", {weekdays: daysSingleString, start: startString, end: endString})}</label>`);
      } else {
        timeWarningLabel = $(`<label class='list-group-item list-group-item-danger font-weight-bold' data-translation-key="editor.truck-attributes.time-domain-warning">${this._localization.translate("editor.truck-attributes.time-domain-warning-detailed", {start: startString, end: endString})}</label>`);
      }
      balloonContainer.find('#truck-attribute-list').append(timeWarningLabel);
    }

    if(isSoftRestriction) {
      balloonContainer.find('#truck-attribute-edit-container').addClass('d-none');
      balloonContainer.find('#truck-attribute-remove-container').removeClass('col-lg-6');
      balloonContainer.find('#truck-attribute-remove-container').addClass('col-lg-12');
    } else if(createdByUser) {
      balloonContainer.find('#truck-attribute-edit-container').removeClass('d-none');
      balloonContainer.find('#truck-attribute-edit-container').removeClass('col-lg-6');
      balloonContainer.find('#truck-attribute-edit-container').addClass('col-lg-12');
      balloonContainer.find('#truck-attribute-remove-container').addClass('d-none');
    } else {
      balloonContainer.find('#truck-attribute-edit-container').removeClass('d-none');
      balloonContainer.find('#truck-attribute-remove-container').addClass('col-lg-6');
      balloonContainer.find('#truck-attribute-remove-container').removeClass('col-lg-12');
    }

    return balloonContainer;
  }

  createSegmentWarningBalloon(segment) {
    let balloonContainer = $('#segment-warning-balloon-template').clone();
    //balloonContainer.find('#segment-warning-text').html('');

    //let warningDescription = $(`<label class='list-group-item'>${this._localization.translate(`segment-errors.${segment._attributes.checkCode}`)}</label>`);
    //balloonContainer.find('#segment-warning-text').append(warningDescription);

    if(segment._attributes.SegmentType !== constants.SEGMENT_TYPE_NEW_STREET) {
      balloonContainer.find('#warning-segment-fix-container').removeClass('d-none');
    } else {
      balloonContainer.find('#warning-segment-edit-container').removeClass('d-none');
    }

    return balloonContainer;
  }

  createEmptyTASegment(coordinates, originalTA, olrCode) {
    let attributes = {};
    attributes.detourEditor_originalTruckAttributes = this.createRestrictionStringFromMarker(originalTA);
    attributes.MapVersion = this.currentBuildVersion;
    attributes.detourEditor_created = new Date().toISOString();
    attributes.detourEditor_modified = new Date().toISOString();
    attributes.detourEditor_modifiedBy = this.user._username;
    attributes.direction = 3;
    attributes.ovld_TA = "";
    attributes.truckattributes = "truckattributes";
    attributes.validity = 0;

    let segment = new Segment(null, coordinates, olrCode, attributes, constants.SEGMENT_NEW);
    segment.type = constants.SEGMENT_TRUCK_ATTRIBUTES;
    this._latestSegment = segment;
    this._file.addSegment(segment);
    this.drawOnMap(false);

    Ui.addSegmentListRow(segment, this._localization);
    //this.updateSegmentList();
    this.updateSaveBadge();
  }

  addListeners() {
    // noinspection JSUnresolvedFunction
    this.uiSegmentListModal.on('show.bs.modal', () => {
      if(!window.dataTable) {
        this.updateSegmentList()
          .then(() => {
            this.addSegmentListListener();
          });
      }
    });

    // noinspection JSUnresolvedFunction
    this.uiEditFileInfoModal.on('show.bs.modal', () => {
      $('#changeFileInfoName').val(this._file.name);
    });

    // noinspection JSUnresolvedFunction
    $('#buttonSaveChanges').on('click', () => {
      this.saveAll();
    });

    // noinspection JSUnresolvedFunction
    $('#changeFileInfoSubmit').on('click', () => {
      const newName = $('#changeFileInfoName').val();

      if (newName.length > 0) {
        this._file.name = newName;
        $('.track-name-panel').html(newName);
        this.uiEditFileInfoModal.modal('hide');
      } else {
        Ui.showModalError('errors.please-add-a-file-name');
      }
    });

    // noinspection JSUnresolvedFunction
    $('.map').on('mousemove', (event) => {
      this.mousePositionOnMap = {
        left: event.originalEvent.pageX,
        top: event.originalEvent.pageY,
      };
    });

    // noinspection JSUnresolvedFunction
    $('#buttonUndo').on('click', () => {
      const newVersion = this._caretaker.getPrevious();
      if (newVersion === null) return;

      this.replaceOpenedFile(newVersion);
    });

    // noinspection JSUnresolvedFunction
    $('#buttonRedo').on('click', () => {
      const newVersion = this._caretaker.getNext();
      if (newVersion === null) return;

      this.replaceOpenedFile(newVersion);
    });

    $('#buttonRecheckSegments').off().on('click', () => {
        this.checkSegments(true);
    });

    $('#buttonRecheckSegmentsQuick').off().on('click', () => {
        this.checkSegments(true);
        this.uiMapVersionWarning.modal('hide');
    });

    this.uiCreateSegmentForm.on('keypress', (event) => {
      if (event.which === 13) {
        event.preventDefault();
        this.uiCreateSegmentForm.trigger('submit');
      }
    });

    this.uiCreateSegmentForm.on('keyup', (event) => {
      if(event.which === 27) {
        this.uiCreateSegmentModal.modal('hide');
      }
    });

    this.uiModifyStreetForm.on('keypress', (event) => {
      if (event.which === 13) {
        event.preventDefault();
        this.uiModifyStreetForm.trigger('submit');
      }
    });

    this.uiModifyStreetForm.on('keyup', (event) => {
      if(event.which === 27) {
        this.uiModifyStreetModal.modal('hide');
      }
    });

    this.uiCreateDepotModal.on('keypress', (event) => {
      if (event.which === 13) {
        event.preventDefault();
        this.uiCreateDepotModal.trigger('submit');
      }
    });

    this.uiCreateDepotModal.on('keyup', (event) => {
      if(event.which === 27) {
        this.uiCreateDepotModal.modal('hide');
        if(this._currentEditedSegment) this._currentEditedSegment.attributes = this._segmentInitialState.attributes;
      }
    });

    this.uiCreateDepotModal.find('#createDepotFormCancel').off().on('click', (event) => {
      if(this._currentEditedSegment) this._currentEditedSegment.attributes = this._segmentInitialState.attributes;
    });

    this.uiCreateCutPointModal.on('keypress', (event) => {
      if (event.which === 13) {
        event.preventDefault();
        this.uiCreateCutPointModal.trigger('submit');
      }
    });

    this.uiCreateCutPointModal.on('keyup', (event) => {
      if(event.which === 27) {
        this.uiCreateCutPointModal.modal('hide');
      }
    });


    this.uiCreateSegmentForm.find("#showTimeEditModal").off().on('click', (event) => {
      event.preventDefault();
      this.uiCreateSegmentTimeFrameModal.modal("show");
    });

    this.uiCreateSegmentForm.find('#showTruckAttributeModal').off().on('click', (event) => {
      event.preventDefault();
      this.uiCreateSegmentTruckAttributeModal.modal("show");
    });

    this.uiCreateSegmentModal.find('#createSegmentFormCancel').off().on('click', (event) => {
      this._currentEditedSegment.attributes = this._segmentInitialState.attributes;
    });

    this.uiCreateSegmentModal.find('#createSegmentFormClose').off().on('click', (event) => {
      this._currentEditedSegment.attributes = this._segmentInitialState.attributes;
    });

    this.uiModifyStreetModal.find('#showTruckAttributeModalModifyStreet').off().on('click', (event) => {
      event.preventDefault();
      this.uiCreateSegmentTruckAttributeModal.modal("show");
    });

    this.uiModifyStreetModal.find('#showTimeEditModalModifyStreet').off().on('click', (event) => {
      event.preventDefault();
      this.uiCreateSegmentTimeFrameModal.modal("show");
    });

    this.uiCreateSegmentTruckAttributeModal.off().on('hidden.bs.modal', () => {
      $("body").addClass('modal-open');
    });

    this.uiCreateSegmentTruckAttributeModal.find('#truckAttributeForm').off().on('submit', (event) => {
      event.preventDefault();
      this.uiCreateSegmentTruckAttributeModal.modal("hide");
    });

    // noinspection JSUnresolvedFunction
    this.uiCreateSegmentForm.on('submit', (event) => {
      const name = this.uiCreateSegmentModal.find('#createSegmentFormName').val();

      const errors = [];
      let hasAttributes = this.parseTruckAttributesForm() !== '';
      let typeValue = this.uiCreateSegmentModal.find('input[name="segment-type"]:checked').val();

      if (name.length > 0) {
        if(!OpenFile.isNameValid(name)) {
          errors.push(this._localization.translate('errors.invalid-characters-in-name'));
        }
      }
      /*
      if ($('#createSegmentFormHash').val() === '' && this._file.getSegmentByName(name)) {
        errors.push(this._localization.translate('errors.segment-name-already-in-use'));
      }

      if(!hasAttributes && isNaN(typeValue)) {
        errors.push(this._localization.translate('errors.empty-segment'));
      }*/

      if(hasAttributes && typeValue === '0') {
        errors.push(this._localization.translate('errors.attributes-with-closure'));
      }

      if (errors.length === 0) {
        this.finishAddSegment();
      } else {
        Ui.showModalError(errors.join('<br />'));
      }

      event.preventDefault();
    });

    this.uiModifyStreetForm.on('submit', (event) => {

      const name = $('#modifyStreetFormName').val();
      const streetName = this.uiModifyStreetModal.find('#attributeStreetName').val();

      const errors = [];

      if (name.length > 0) {
        if(!OpenFile.isNameValid(name)) {
          errors.push(this._localization.translate('errors.invalid-characters-in-name'));
        }
      }

      if (streetName.length > 0) {
        if(!OpenFile.isNameValid(streetName)) {
          errors.push(this._localization.translate('errors.invalid-characters-in-streetname'));
        }
      }

      if (errors.length === 0) {
        this.finishAddStreetSegment();
      } else {
        Ui.showModalError(errors.join('<br />'));
      }

      event.preventDefault();
    });

    this.uiCreateCutPointModal.on('submit', (event) => {
      event.preventDefault();
      this.finishCutStreet();
    });

    this.uiCreateDepotModal.on('submit', (event) => {
      event.preventDefault();
      const name = $('#createDepotFormNameLabel').val();

      const errors = [];

      if (name.length > 0) {
        if(!OpenFile.isNameValid(name)) {
          errors.push(this._localization.translate('errors.invalid-characters-in-name'));
        }
      }

      if (errors.length === 0) {
        this.finishAddDepot();
      } else {
        Ui.showModalError(errors.join('<br />'));
      }
    });

    // noinspection JSUnresolvedFunction
    $('#downloadOpenFile').on('click', (element) => {
      this.download();
      element.preventDefault();
    });

    $('#createSegmentFormSpeed').on('input', (event) => {
      if (event.target.value < 0) {
        $('#createSegmentFormSpeed').val(0);
      }

      if (event.target.value > 130) {
        $('#createSegmentFormSpeed').val(130);
      }
    });

    $('#prioritySlider').on('input', (event) => {
      $('#prioritySliderLabel').html(this._localization.translate('editor.priority-slider-title', {value:event.target.value}))
    });

    // SEGMENT BUTTONS LISTENERS
    // noinspection JSUnresolvedFunction
    this.addSegmentListListener();

    this.uiCreateSegmentModal.off('change').on('change', 'input[name=createSegmentFormDirection]', () => {
      const direction = $('[name="createSegmentFormDirection"]:checked').val();

      this._currentEditedSegment.attributes.direction = parseInt(direction, 10);

      this.updateModalMap(this._currentEditedSegment);
    });

    this.uiCreateSegmentModal.find('#createSegmentNewRoadSpeed').off('change').on('change', (event) => {
      const originalRoadSpeed = this._currentEditedSegment.getAttributeByName('detourEditor_originalRoadSpeed');
      let newSpeed = parseInt(event.currentTarget.value);

      if(isNaN(newSpeed)) {
        newSpeed = originalRoadSpeed;
      } else if (newSpeed <= 0) {
        newSpeed = 1;
      }

      this._currentEditedSegment.attributes.NewSpeed = newSpeed;
      this.updateSegmentButtonModifySpeed(newSpeed, originalRoadSpeed);
      this.updateModalMap(this._currentEditedSegment);
    });

    this.uiCreateSegmentTimeFrameModal.off().on('hidden.bs.modal', () => {
      $("body").addClass('modal-open');
    });

    this.uiCreateSegmentTimeFrameModal.off("click").on("click", "#timeFrameSelectorApply", (event) => {
      const segmentTimeFrameTimeDomain = $("#segmentTimeFrameTimeDomain").val();
      const segmentTimeFrameStartDate = $("#segmentTimeFrameStartDate").val();
      const segmentTimeFrameEndDate = $("#segmentTimeFrameEndDate").val();
      const segmentTimeFrameMessage = $("#segmentTimeFrameMessage").val();

      this.uiCreateSegmentTimeFrameModal.modal("hide");

      if( segmentTimeFrameMessage === "") {
        return;
      }

      $("#timeframe-description").html(segmentTimeFrameMessage);
      $('#timeframe-description-modify-street').text(segmentTimeFrameMessage);


      let startDate = new Date();
      let startDateDomain = '';
      let endDate = new Date();
      let dateDiff = {};

      if(segmentTimeFrameStartDate !== "") {
        startDate = new Date(Date.parse(segmentTimeFrameStartDate));
        if(!OpenFile.isRegularSegment(this._currentEditedSegment)){
          this._currentEditedSegment.attributes.detourEditor_start = segmentTimeFrameStartDate;
        } else {
          this._currentEditedSegment.attributes.start = segmentTimeFrameStartDate;
        }
      }

      if(segmentTimeFrameEndDate !== "") {
        endDate = new Date(Date.parse(segmentTimeFrameEndDate));
        let diff = endDate.getTime() - startDate.getTime();
        dateDiff.diffD = Math.floor(diff / 86400000);
        dateDiff.diffH = Math.floor((diff % 86400000) / 3600000);
        dateDiff.diffM = Math.round(((diff % 86400000) % 3600000) / 60000);
        startDateDomain = `[(y${startDate.getFullYear()}M${startDate.getMonth()+1}d${startDate.getDate()}h${startDate.getHours()}m${startDate.getMinutes()}s${startDate.getSeconds()}){d${dateDiff.diffD}h${dateDiff.diffH}m${dateDiff.diffM}}]`;
        if(!OpenFile.isRegularSegment(this._currentEditedSegment)) {
          this._currentEditedSegment.attributes.detourEditor_end = segmentTimeFrameEndDate;
        } else {
          this._currentEditedSegment.attributes.end = segmentTimeFrameEndDate;
        }
      } else {
        startDateDomain = `[(y${startDate.getFullYear()}M${startDate.getMonth()+1}d${startDate.getDate()}h${startDate.getHours()}m${startDate.getMinutes()}s${startDate.getSeconds()}){y1000}]`;
        delete this._currentEditedSegment.attributes.end;
      }

      if(segmentTimeFrameTimeDomain !== "") {
        startDateDomain += `*${segmentTimeFrameTimeDomain}`;

        if(OpenFile.isRegularSegment(this._currentEditedSegment)) {
          this._currentEditedSegment.attributes.TimeDomain = segmentTimeFrameTimeDomain;
        } else {
          this._currentEditedSegment.attributes.detourEditor_TimeDomain = '[' + startDateDomain + ']';
          //this._currentEditedSegment.attributes.detourEditor_TimeDomain = segmentTimeFrameTimeDomain;
        }
      } else if(!OpenFile.isRegularSegment(this._currentEditedSegment)) {
        this._currentEditedSegment.attributes.TimeDomain = startDateDomain;
      }

      this.updateModalMap(this._currentEditedSegment);
    });

    this.uiModifyStreetModal.off('change').on('change', 'input[name=modifyStreetFormRestrictions]', () => {
      let rsValue = $('[name="modifyStreetFormRestrictions"]:checked').val();

      if(this._currentEditedSegment.hasOwnProperty.call(this._currentEditedSegment._attributes, 'modified_street')) {

        if(this._currentEditedSegment.getAttributeByName('detourEditor_TimeDomain')) {
          this._currentEditedSegment._attributes.RS_TD = rsValue;
        } else {
          this._currentEditedSegment._attributes.modified_street.RS = rsValue;
        }
      }

      this.updateGeometryMap(this._currentEditedSegment);
    });

    $(document).on('hide.bs.modal', '.modal-create-segment', () => {
      this.cancelAddSegment();
    });

    $(document).on('hide.bs.modal', '.modal-modify-street', () => {
      this.cancelAddStreetSegment();
    })
  }

  setPermissions() {
    if(!this.permissions) return;

    if(this.permissions.hasOwnProperty('editClosures')) {
      this.hasSegmentPermission = this.permissions.editClosures;
    }

    if(this.permissions.hasOwnProperty('editGeometry')) {
      this.hasGeometryPermission = this.permissions.editGeometry;
    }

    if(this.permissions.hasOwnProperty('editTurnRestrictions')) {
      this.hasTurnRestrictionPermission = this.permissions.editTurnRestrictions;
    }

    if(!this.hasSegmentPermission && !this.hasTurnRestrictionPermission) {
      $('#initDrawSegment').parent().hide();
      $(document).off('keydown.segmentdraw.segment');
      $(document).off('keyup.segmentdraw.segment');
    }

    if(!this.hasGeometryPermission) {
      $('#initDrawStreetSegment').parent().hide();
      $('#initCutStreet').parent().hide();
      $('#initDepot').parent().hide();
      $(document).off('keydown.segmentdraw.geometry');
      $(document).off('keyup.segmentdraw.geometry');
    }
  }

  addSegmentListListener() {
    const segmentList = $('#segmentList');
    segmentList.off('click', '#btn-segment-zoom').on('click', '#btn-segment-zoom', (event) => {
      const segment = this._file.getSegmentByHash($(event.currentTarget).attr('rel'));
      this.zoomToSegment(segment);
    });

    // noinspection JSUnresolvedFunction
    segmentList.off('click', '#btn-segment-save').on('click', '#btn-segment-save', (event) => {
      const segment = this._file.getSegmentByHash($(event.currentTarget).attr('rel'));
      this.saveSegment(segment, false);
    });

    // noinspection JSUnresolvedFunction
    segmentList.off('click', '#btn-segment-edit').on('click', '#btn-segment-edit', (event) => {
      const segment = this._file.getSegmentByHash($(event.currentTarget).attr('rel'));
      this.prepareEditSegment(segment);
    });

    // noinspection JSUnresolvedFunction
    segmentList.off('click', '#btn-segment-delete').on('click', '#btn-segment-delete', (event) => {
      const segment = this._file.getSegmentByHash($(event.currentTarget).attr('rel'));
      this.deleteSegment(segment);
    });

    // noinspection JSUnresolvedFunction
    segmentList.off('click', '#btn-segment-undo').on('click', '#btn-segment-undo', (event) => {
      const segment = this._file.getSegmentByHash($(event.currentTarget).attr('rel'));
      this.undoSegment(segment);
    });

    this.hideSegmentListButtons(segmentList);

    if(window.dataTable) {
      window.dataTable.on('draw', (e) => {
        this.hideSegmentListButtons(segmentList);
      });
    }
  }

  hideSegmentListButtons(segmentList) {
    if(!this.hasTurnRestrictionPermission) {
      segmentList.find(`[data-segmenttype="Maneuver"]`).addClass('d-none');
    }

    if(!this.hasSegmentPermission) {
      segmentList.find(`[data-segmenttype="Segment"]`).addClass('d-none');
    }

    if(!this.hasGeometryPermission) {
      segmentList.find(`[data-segmenttype="Geometry"]`).addClass('d-none');
    }
  }

  removeListeners() {
    this.uiSegmentListModal.off('show.bs.modal');
    this.uiEditFileInfoModal.off('show.bs.modal');
    $('#buttonSaveChanges').off('click');
    $('#changeFileInfoSubmit').off('click');
    $('.map').off('mousemove');
    $('#buttonUndo').off('click');
    $('#buttonRedo').off('click');
    $('#createSegmentFormName').off('input');
    this.uiCreateSegmentForm.off('submit');
    this.uiModifyStreetForm.off('submit');
    this.uiCreateCutPointModal.off('submit');
    this.uiCreateDepotModal.off('submit');
    $('#createSegmentFormSubmit').off('click');
    $('#createSegmentFormCancel').off('click');
    $('#downloadOpenFile').off('click');
    $('#createSegmentFormSpeed').off('input');
    $('#segmentList').off('click');
  }

  replaceOpenedFile(newVersion) {
    $('.track-name-panel').html(newVersion.name);
    this._file = File.deserialize(newVersion);
    this._file.onChange = fileVersion => this.fileChanged(fileVersion);
    this.drawOnMap(false);
    this.updateSegmentList();
    this.updateSaveBadge();
    this._turnRestrictions.draw();
  }

  static calculatePriorityValue(factor) {
    return factor*1;
  }

  static calculatePenalizeValue(factor) {
    return Math.round(((11-factor)*0.1)*10)/10;
  }

  static calculatePriorityFactor(value) {
    return value;
  }

  static calculatePenalizeFactor(value) {
    return 11-(value*10);
  }

  reloadFile() {
    let unsavedChanges = this._file.segments.filter(segment => segment.flag !== constants.SEGMENT_PUBLISHED);
    return new Promise((resolve, reject) => {
      this._api.getFileContents(this._sessionId, this._file)
        .then(res => {
          this._file = res;
          unsavedChanges.forEach(segment => {
            let editedSegment = this._file.getSegmentByOlr(segment.olr);
            if(editedSegment) {
              this._file.replaceSegment(editedSegment, segment);
            } else {
              this._file.addSegment(segment);
            }
          });
          this.drawOnMap(false);
          resolve();
        })
        .catch(err => {
          resolve();
        })
    });
  }

  checkSegments(showModal) {
    this._preloader.showCursorPreloader();
    $('#buttonRecheckSegments').prop('disabled', true);
    this._api.checkFile(this._sessionId, this._file.id, true, false, false)
      .then(res => {
        $('.modal-settings').modal("hide");
        let warningsShowInMap = 0;
        let fixedSegments = 0;

        res.forEach(segment => {

          if(!segment._coordinates) return;

          let centerCoordinate = this.iwTruckAttributes.getCenter(segment._coordinates);
          // segments with no center coordinates have usually only 1 Coordinate / duplicate Coordinates; this makes them unusable
          if(!centerCoordinate) {
            return;
          }

          let currentSeg = this._file.segments.find(current => current.id === segment.id);

          let isFixed = false;
          if(OpenFile.isRegularSegment(segment) && parseFloat(segment._attributes.maxDist) < 20) {
            this.fixSegment(currentSeg, segment);
            fixedSegments++;
            isFixed = true;
          } else if((segment.type === constants.SEGMENT_TYPE_DELETED_ORIGINAL || segment.type === constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL)&& parseFloat(segment._attributes.maxDist) < 20) {
            this.fixSegment(currentSeg, segment);
            isFixed = true;
          }

          if(!OpenFile.isSegmentVisible(segment) || isFixed) return;

          currentSeg._attributes.warningCode = segment._attributes.checkCode;

          let marker = OpenFile.drawWarningMarker(this._map, centerCoordinate, segment._attributes.checkDesc);
          let hoverPolyline;
          let hoverPolylineBG;
          IWEventManager.addCustomListener(marker, 'onmouseover', (e) => {
            this._map.map.openTooltip(centerCoordinate, this._localization.translate(`segment-errors.${segment._attributes.checkCode}`));
            hoverPolylineBG = this._map._renderer.drawPolyline(segment.coordinates, {
              stroke: 'black',
              strokeWidth: 16
            });
            hoverPolyline = this._map._renderer.drawPolyline(segment.coordinates, {
              stroke: 'yellow',
              strokeWidth: 15
            });
            this._map._renderer.render();
          });

          IWEventManager.addCustomListener(marker, 'onmouseout', (e) => {
            this._map.map.removeTooltip();
            if(hoverPolyline) {
              this._map._renderer.removeElement(hoverPolyline);
              this._map._renderer.removeElement(hoverPolylineBG);
            }
          });

          IWEventManager.addCustomListener(marker, 'onclick', (e) => {
            if(event.ctrlKey || event.which !== 1) {
              return;
            }

            let balloonContainer = this.createSegmentWarningBalloon(segment);

            balloonContainer.find('#warning-segment-fix').off().on('click', (e) => {
                e.preventDefault();
                this._map.map.removeInfoBalloon();
                this.fixSegment(currentSeg, segment)
                  .then(this._preloader.hideCursorPreloader())
                  .catch(err => {
                    Ui.showModalError(err);
                  })
            });

            balloonContainer.find('#warning-segment-ignore').off().on('click', (e) => {
              e.preventDefault();
              this._preloader.showCursorPreloader();
              this._map.map.removeInfoBalloon();
              this.ignoreWarning(currentSeg)
                .then(() => {
                  this._map.map.getOverlayManager().getLayer(
                    constants.SEGMENT_MARKERS_LAYER_ID,
                  ).removeOverlay(marker);
                })
                .catch(err => {
                  Ui.showModalError(err);
                })
            });

            balloonContainer.find('#warning-segment-edit').off().on('click', (e) => {
              e.preventDefault();
              this.prepareEditSegment(currentSeg);
            });

            this._map.map.openInfoBalloon(marker._coordinate, balloonContainer.get(0));
          });
          warningsShowInMap++;
        });

        res = res.filter(seg => !OpenFile.isRegularSegment(seg));

        if(showModal) {
          this.updateFileCheckModal(warningsShowInMap, fixedSegments);
        }
      })
      .catch(err => {
        Ui.showModalError(err);
      })
      .finally(() => {
        this._preloader.hideCursorPreloader();
        $('#buttonRecheckSegments').prop('disabled', false);
      })
  }

  fixSegment(oldSegment, newSegment) {
    return new Promise((resolve, reject) => {
      this._api.deleteSegment(this._sessionId, this._file.id, oldSegment)
        .then(() => {
          newSegment.attributes.detourEditor_modified = new Date().toISOString();
          newSegment.attributes.detourEditor_modifiedBy = this.user._username;
          newSegment.attributes.MapVersion = this.currentBuildVersion;
          this._api.addSegment(this._sessionId, this._file.id, newSegment, true)
            .then(segment => {
              this._file.replaceSegment(oldSegment, segment);
              Ui.updateSegmentListRow(segment, this._localization);
              //this.updateSegmentList();
              this.updateSaveBadge();
              this._preloader.hideCursorPreloader();
              this.drawOnMap(false, true);
              resolve();
            })
            .catch(err => {
              reject(err);
            })
        })
        .catch(err => {
          reject(err);
        })
    })
  }

  ignoreWarning(segment) {
    return new Promise((resolve, reject) => {
      if(this.currentBuildVersion) {
        segment.attributes.MapVersion = this.currentBuildVersion;
        segment.attributes.detourEditor_modified = new Date().toISOString();
        segment.attributes.detourEditor_modifiedBy = this.user._username;

        this._api.changeModifiedStreet(this._sessionId, this._file.id, segment)
          .then(res => {
            this._file.replaceSegment(segment, res);
            Ui.updateSegmentListRow(res, this._localization);
            //this.updateSegmentList();
            this.updateSaveBadge();
            this._preloader.hideCursorPreloader();
            //this.drawOnMap(false, true);
            resolve();
          })
          .catch(err => {
            reject(err);
          })

      }

    })
  }

  updateFileCheckModal(warningsShowInMap, fixedSegments) {
    const warningsText = $('#detected-warnings-text');
    const fixedSegmentsText = $('#fixed-segments-text');

    if(warningsShowInMap > 0) {
      warningsText.removeClass('d-none');
      if(warningsShowInMap === 1) {
        warningsText.html(this._localization.translate('editor.detected-warnings-text-single'));
      } else {
        warningsText.html(this._localization.translate('editor.detected-warnings-text', {value: warningsShowInMap}));
      }
    } else {
      warningsText.addClass('d-none')
    }

    if(fixedSegments > 0) {
      fixedSegmentsText.removeClass('d-none');
      fixedSegmentsText.html(this._localization.translate('editor.fixed-warnings-text', {value: fixedSegments}));
    } else {
      fixedSegmentsText.addClass('d-none');
    }

    if(fixedSegments === 0 && warningsShowInMap === 0) {
      $('#no-warnings-text').removeClass('d-none');
    } else {
      $('#no-warnings-text').addClass('d-none');
    }

    $('.modalFileCheckResult').modal('show');
  }

  getBuildVersion() {
    return new Promise((resolve, reject) => {
      this._api.getMapBuildVersion()
        .then(res => {
          this.currentBuildVersion = res;
          resolve();
        })
        .catch(error => {
          console.error(error);
          reject();
        })
    })
  }

  hasReachedDetourLimit() {
    return new Promise((resolve, reject) => {
      this._storage.getOption(constants.DETOUR_LIMIT)
        .then((result) => {
          resolve(!!(result && result <= this.checkTotalChangesInFile()));
        });
    })
  }

  checkTotalChangesInFile() {
    let totalCount = 0;
    this._file.segments.forEach(segment => {
      if(constants.LIMITED_SEGMENTS.includes(segment._attributes.SegmentType)) totalCount++;
    });
    return totalCount;
  }

  checkFileMapVersion(segments) {
    let hasCurrentVersion = true;
    segments.forEach(segment => {
      if(segment.attributes.MapVersion !== this.currentBuildVersion) hasCurrentVersion = false;
    });
    return hasCurrentVersion;
  }

  createBulkSegmentBody(segments) {
    return segments.map((segment) => {

      let modStreetAttributes = [];

      let attributes = Object.keys(segment.attributes).forEach(attribute => {
        if(attribute === constants.SEGMENT_MODIFIED_STREET) {
          let keys = Object.keys(segment.attributes[constants.SEGMENT_MODIFIED_STREET]);
          modStreetAttributes = keys.map(modStreetAttribute => {
            return {
              name: modStreetAttribute,
              value: segment.attributes[constants.SEGMENT_MODIFIED_STREET][modStreetAttribute]
            }
          })
        }
      });

      let bulkSegment = {
        coordinates: segment.coordinates.map((coord) => {
          return {
            lat: coord.getY(),
            lon: coord.getX()
          }
        }),
        openlr: segment.olr,
        attributes: Object.keys(segment.attributes).filter(attribute => attribute !== constants.SEGMENT_MODIFIED_STREET).map(attribute => {
          return {
            name: attribute,
            value: segment.attributes[attribute].toString()
          }
        })
      };

      modStreetAttributes.forEach(att => {
        bulkSegment.attributes.push(att);
      });

      return bulkSegment
    });

    /*
    return segments.map((segment) => { // eslint-disable-line
      return {
        coordinates: segment.coordinates.map((coord) => {
          return {
            lat: coord.getY(),
            lon: coord.getX()
          }
        }),
        openlr: segment.olr,
        attributes: Object.keys(segment.attributes).map(attribute => {

          if(attribute === constants.SEGMENT_MODIFIED_STREET) {
            let keys = Object.keys(segment.attributes[constants.SEGMENT_MODIFIED_STREET]);
            return keys.map(modStreetAttribute => {
              return {
                name: modStreetAttribute,
                value: segment.attributes[constants.SEGMENT_MODIFIED_STREET][modStreetAttribute]
              }
            })
          }

          return {
            name: attribute,
            value: segment.attributes[attribute].toString()
          }
        })
      }
    });
    */
  }

  static isSegmentVisible(segment) {
    if (segment.coordinates.length === 0) return false;
    if (segment.attributes.detourEditor_editedOriginal) return false;
    //if (segment._attributes.SegmentType === constants.SEGMENT_TYPE_DISSECTED_STREET) return false;
    return !(segment._attributes.SegmentType === constants.SEGMENT_TYPE_DELETED_ORIGINAL && !segment._attributes.detourEditor_deletedByUser && segment._attributes.SegmentType !== constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL);
  }

  static isRegularSegment(segment) {
    return segment.type === constants.SEGMENT_PENALIZE ||
      segment.type === constants.SEGMENT_PRIORITIZE ||
      segment.type === constants.SEGMENT_CLOSE ||
      segment.type === constants.SEGMENT_UNBLOCK ||
      segment.type === constants.SEGMENT_TRUCK_ATTRIBUTES ||
      (segment.type === constants.SEGMENT_TYPE_DELETED_ORIGINAL && segment.attributes.detourEditor_deletedByUser) ||
      segment.type === constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL;
  }

  static sanitize(string) {
    const map = {
      '<': ' ',
      '>': ' ',
      "/": ' ',
    };
    const reg = /[<>/]/ig;
    return string.replace(reg, (match)=>(map[match]));
  }

  static isNameValid(string) {
    let valid = true;
    constants.INVALID_CHARACTERS.forEach( char => {
        if (string.includes(char)) {
          valid = false;
        }
      }
    );
    return valid;
  }

  static getTotalPolylineLength(coordinates, originalSpeed, newSpeed) {
    let totalDistance = 0;

    for(let i = 0; i < coordinates.length; i++) {
      if(i+1 < coordinates.length) {
        const distance = coordinates[i].distanceFrom(coordinates[i+1]);
        totalDistance += distance;
      }
    }

    const secondsTravelledOriginal = totalDistance/(originalSpeed/3.6);
    const secondsTravelledNewSpeed = totalDistance/(newSpeed/3.6);

    const differenceInSeconds = secondsTravelledNewSpeed - secondsTravelledOriginal;
  }

  destroy() {
    this.mergeGeometryChanges('');
    this._file = null;
    this._latestSegment = null;
    this._turnRestrictions.disable();
    this._segmentDrawer.deconstruct();

    this._addressRouting.removeCurrentRoute();

    this._map.renderer.clearContainer();

    this._map.map.getOverlayManager().getLayer(
      constants.SEGMENT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._map.map.getOverlayManager().getLayer(
      constants.CUT_POINT_MARKERS_LAYER_ID,
    ).removeAllOverlays();

    this._caretaker.reset();
    this.removeListeners();
    this.iwTruckAttributes.setClickHandler(null);
    $('#segment-minimap').remove();
    $('#segment-minimap-container').append($('<div id="segment-minimap">'));
    window.dataTable = null;
  }

  get totalUnsavedChanges() {
    return this._totalUnsavedChanges;
  }
}

module.exports = OpenFile;
